import React from 'react'
import { useState, useEffect, useRef } from 'react';
import Select, { components } from 'react-select';
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import axios from 'axios'
import ToastNotification from '../../../components/ToastNotification';
import { Modal, Button, Table, Form } from "react-bootstrap";
import { CiEdit } from "react-icons/ci";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { FaDownload } from "react-icons/fa6";
import logo from '../../../assets/logo.png';
import mammoth from "mammoth";
import "react-quill/dist/quill.snow.css";
import { MdDeleteForever } from "react-icons/md";
import { useLoading } from '../../../context/LoadingContext';
import jsPDF from "jspdf";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import "jspdf-autotable"; // <-- this is necessary
import autoTable from "jspdf-autotable";
import html2pdf from "html2pdf.js";
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';
import { toWords } from "number-to-words";

const SaleQuotation = ({ adminData, companyID, branchID, financialYear }) => {
  const searchInputRef = useRef(null);
  const navigate = useNavigate();
  const { setLoading } = useLoading();
  const [showForm, setShowForm] = useState(false);
  const [content, setContent] = useState("");
  const [searchTerm, setSearchTerm] = useState('');
  const location = useLocation();
  const mode = location.state?.mode;
  const partyId = location.state?.partyId;
  const editData = location.state?.data;


  const [offset, setOffset] = useState(0);
  const limit = 20;
  const [hasMore, setHasMore] = useState(true);
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [isLocked, setIsLocked] = useState(false);
  const [fy, setFy] = useState([]);
  const [validUpto, setValidUpto] = useState(null);

  const [financialRange, setFinancialRange] = useState({
    from_date: '',
    to_date: ''
  });


  const getTodayDateTime = () => {
    const now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    return now.toISOString().slice(0, 16);
  };
  const [formItems, setFormItems] = useState({
    party: '',
    cust_enq: '',
    quotation_date: getTodayDateTime(),
    sale_person: '',
    technician: '',
    grand_total: '',
    total_gst: "",
    sub_total: "",
    remark: 'By using this service, you agree to the terms and conditions.',
    description: '',
    ref_doc: '',
    type_acc: 'sale_quotation',
    customLetter: '',
    subject: '',
    customLetterHTML: '',
    edit_by: '',
    edit_date: '',
    added_by: '',
    additionalDetails: [],
    branchId: '',
    delivery: '',
  })


  const [files, setFiles] = useState({
    file: null,

  })
  const [formData, setFormData] = useState([]);
  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };
  const [search, setSearch] = useState("");
  const [searchItem, setSearchItem] = useState("");
  const [showPartyModal, setShowPartyModal] = useState(false);
  const [showItemModal, setShowItemModal] = useState(false);
  const [items, setItems] = useState([]);
  const [selectedItemId, setSelectedItemId] = useState("");
  const [partyOptions, setPartyOptions] = useState([]);
  const [detail, setDetail] = useState([]);
  const [user, setUser] = useState([]);
  const [subTotal, setSubTotal] = useState(0);
  const [totalTax, setTotalTax] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [selectedParty, setSelectedParty] = useState("");
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [quotation, setQuotation] = useState([]);
  const [editingCompanyId, setEditingCompanyId] = useState(null);
  const [selectedPrint, setSelectedPrint] = useState({});
  const [showLetterModal, setShowLetterModal] = useState(false);
  const [selectedQuotation, setSelectedQuotation] = useState(null);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [chargeMaster, setChargeMaster] = useState([]);
  const [chargeOptions, setChargeOptions] = useState([]);
  const [rows, setRows] = useState([]);
  const [isInitialEditLoad, setIsInitialEditLoad] = useState(false);
  const [branchDetail, setBranchDetail] = useState([])
  const [useDefaultShipping, setUseDefaultShipping] = useState(true);
  const [company, setCompany] = useState([]);

  const [payableAmount, setPayableAmount] = useState(0);
  const [cgst, setCgst] = useState(0);
  const [sgst, setSgst] = useState(0);
  const [igst, setIgst] = useState(0);
  const [roundOff, setRoundOff] = useState(0);
  const [billDiscountPercent, setBillDiscountPercent] = useState(0);
  const [billDiscountAmount, setBillDiscountAmount] = useState(0);
  const [afterBillDiscountAmount, setAfterBillDiscountAmount] = useState(0);
  const [billDiscountType, setBillDiscountType] = useState("percent");
  const [billDiscountValue, setBillDiscountValue] = useState(0);
  const [extraChargesTotal, setExtraChargesTotal] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState("0.00");

  useEffect(() => {
    if (showPartyModal) {
      setTimeout(() => {
        searchInputRef.current?.focus();
      }, 100);
    }
  }, [showPartyModal]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormItems(prev => ({
      ...prev,
      [name]: value
    }));
  };

  useEffect(() => {
    if (mode === "edit" && editData) {
      handleEdit(editData);
    }
  }, [editData, mode]);

  const handleAddClick = () => {
    setShowForm(true);
  }

  const handleFileChange = async (e) => {
    const file = e.target.files[0];

    const fieldName = e.target.name;


    if (file) {
      const fileSizeInMB = file.size / (1024 * 1024);
      if (fileSizeInMB > 2) {
        setToast("File size is too large! Please upload a file smaller than 2MB.", 'danger')
        return;
      }
      setFiles(prevFiles => ({ ...prevFiles, [e.target.name]: file }));
    }

    if (fieldName === "customLetter") {
      if (!file.name.endsWith(".docx")) {
        setToast("Please upload a .docx file for Custom Letter", "danger");
        return;
      }

      const arrayBuffer = await file.arrayBuffer();
      const result = await mammoth.convertToHtml({ arrayBuffer });

      // Set ReactQuill content
      setContent(result.value);
    }


  };


  const handleSelectChange = (e) => {
    const id = e.target.value;
    if (!id) return;


    const selectedItem = items.find((i) => i.id == id);

    if (!selectedItem) return;

    // // Add row to table
    // setFormData((prev) => [
    //   ...prev,
    //   {
    //     id: selectedItem.id,
    //     name: selectedItem.name,
    //     qty: 0,
    //     rate: selectedItem.salePriceRetailer || 0,
    //     gst: "",
    //     amount: "",
    //     tax: selectedItem.tax || "",
    //   },
    // ]);

    setFormData((prev) => [
      ...prev,
      {
        id: selectedItem.id,
        name: selectedItem.name,
        qty: 0,
        rate: selectedItem.rate || 0,
        amount: "",
        tax: 0,
        hsn: selectedItem.hsn || 0,

      },
    ]);
  };

  const filtered = partyOptions.filter(
    (p) =>
      p.label.toLowerCase().includes(search.toLowerCase()) ||
      (p.phone && p.phone.toLowerCase().includes(search.toLowerCase())) ||
      (p.address && p.address.toLowerCase().includes(search.toLowerCase()))
  );

  useEffect(() => {
    if (isEditMode) {
      setTimeout(() => setIsInitialEditLoad(false), 0);
    }
  }, [formData]);


  //   const handleFormItemChange = (index, field, value) => {
  //      if (isEditMode && isInitialEditLoad) {
  //     // Use DB totals and DON'T recalc
  //     return;
  //   }


  //     const updated = [...formData];


  //     updated[index][field] = value;


  //     const qty = parseFloat(updated[index].qty) || 0;
  //     const rate = parseFloat(updated[index].rate) || 0;
  //     const tax = parseFloat(updated[index].tax) || 0; // your GST %

  //     const baseAmount = qty * rate;
  //     const taxAmount = parseFloat(((baseAmount * tax) / 100).toFixed(2));
  //     const totalAmount = parseFloat((baseAmount + taxAmount).toFixed(2));

  //     updated[index].baseAmount = baseAmount;
  //     updated[index].taxAmount = taxAmount;
  //     updated[index].amount = totalAmount;

  //     setFormData(updated);



  //     const subTotal = updated.reduce((sum, item) => sum + (item.baseAmount || 0), 0);
  //     const totalGst = updated.reduce((sum, item) => sum + (item.taxAmount || 0), 0);

  // const chargesTotal = (formItems?.additionalDetails ?? []).reduce(
  //   (sum, item) => sum + (Number(item.value2) || 0),
  //   0
  // );

  // const grandTotal =
  //   updated.reduce((sum, item) => sum + (Number(item.amount) || 0), 0) +
  //   chargesTotal;


  //     setSubTotal(subTotal.toFixed(2));
  //     setTotalTax(totalGst.toFixed(2));
  //     setGrandTotal(grandTotal.toFixed(2));
  //   };
  const handleFormItemChange = (index, field, value) => {
    const updatedItems = [...formData];

    updatedItems[index][field] = value;

    const qty = parseFloat(updatedItems[index].qty) || 0;
    const rate = parseFloat(updatedItems[index].rate) || 0;
    const taxPercent = parseFloat(updatedItems[index].tax) || 0;
    const discountPercent = parseFloat(updatedItems[index].discount) || 0;



    // Before discount
    const baseAmount = qty * rate;

    // Discount calculation
    const discountAmount = parseFloat(
      ((baseAmount * discountPercent) / 100).toFixed(2)
    );

    // After discount
    const discountedAmount = baseAmount - discountAmount;

    // GST calculation after discount
    const taxAmount = parseFloat(
      ((discountedAmount * taxPercent) / 100).toFixed(2)
    );

    // Final amount
    const totalAmount = parseFloat(
      (discountedAmount + taxAmount).toFixed(2)
    );

    updatedItems[index].baseAmount = baseAmount;
    updatedItems[index].discountAmount = discountAmount;
    updatedItems[index].discountedAmount = discountedAmount;
    updatedItems[index].taxAmount = taxAmount;
    updatedItems[index].amount = totalAmount;

    setFormData(updatedItems);

    recalcTotals(
      updatedItems,
      formItems?.additionalDetails || [],
      billDiscountValue,
      billDiscountType
    );
  };


  const handleDeleteItem = (indexToRemove) => {
    const newItems = formData.filter((_, idx) => idx !== indexToRemove);
    const currentExtra = formItems.additionalDetails || [];

    recalcTotals(
      newItems,
      currentExtra,
      billDiscountValue,
      billDiscountType
    );

    setFormData(newItems);
  };


  const deleteRow = (indexToRemove) => {
    const newExtra = (formItems.additionalDetails || []).filter(
      (_, idx) => idx !== indexToRemove
    );
    setFormItems((prev) => ({ ...prev, additionalDetails: newExtra }));
    recalcTotals(
      formData,
      newExtra,
      billDiscountValue,
      billDiscountType
    );
  };

  const handleViewLetter = (quotation) => {

    setSelectedQuotation(quotation);
    setShowLetterModal(true);
  };



  // const handleGstChange = (value, index) => {
  //   const updated = [...formData];

  //   updated[index].tax = value;
  //   const taxPercent = parseFloat(value) || 0;
  //   const qty = parseFloat(updated[index].qty) || 0;
  //   const rate = parseFloat(updated[index].rate) || 0;

  //   const baseAmount = qty * rate;
  //   const gstAmount = parseFloat(((baseAmount * taxPercent) / 100).toFixed(2));
  //   const amount = parseFloat((baseAmount + gstAmount).toFixed(2));


  //   updated[index].baseAmount = baseAmount;
  //   updated[index].taxAmount = gstAmount;
  //   updated[index].amount = amount;

  //   // Update state
  //   setFormData(updated);




  //   recalcTotals(updated, formItems?.additionalDetails || []);
  // };

  const handleGstChange = (value, index) => {
    const updated = [...formData];

    updated[index].tax = value;

    const taxPercent = parseFloat(value) || 0;
    const qty = parseFloat(updated[index].qty) || 0;
    const rate = parseFloat(updated[index].rate) || 0;
    const discountPercent = parseFloat(updated[index].discount) || 0;


    // Before discount
    const baseAmount = qty * rate;

    // Discount calculation
    const discountAmount = parseFloat(
      ((baseAmount * discountPercent) / 100).toFixed(2)
    );

    // After discount
    const discountedAmount = baseAmount - discountAmount;


    // GST after discount
    const gstAmount = parseFloat(
      ((discountedAmount * taxPercent) / 100).toFixed(2)
    );


    const amount = parseFloat(
      (discountedAmount + gstAmount).toFixed(2)
    );


    updated[index].baseAmount = baseAmount;
    updated[index].discountAmount = discountAmount;
    updated[index].discountedAmount = discountedAmount;
    updated[index].taxAmount = gstAmount;
    updated[index].amount = amount;


    setFormData(updated);

    recalcTotals(
      updated,
      formItems?.additionalDetails || [],
      billDiscountValue,
      billDiscountType
    );
  };



  const formatDateTime = (datetime) => {
    if (!datetime) return "";
    const [date, time] = datetime.split(" ");
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year} ${time}`;
  };

  const addRow = () => {
    setFormItems(prev => ({
      ...prev,
      additionalDetails: [
        ...(prev.additionalDetails || []),
        { id: Date.now(), type: "SGT" }
      ]
    }));
  };



  const handleEdit = async (form) => {
    const locked = isVoucherLocked(form.quotation_date);
    setIsLocked(locked);

    setIsEditMode(true);

    let parsedItems = [];
    try {
      parsedItems = JSON.parse(form.items || "[]");
    } catch (err) {
      console.log("Invalid JSON for items:", err);
    }

    parsedItems = parsedItems.map((item) => {
      const qty = parseFloat(item.qty) || 0;
      const rate = parseFloat(item.rate) || 0;
      const tax = parseFloat(item.tax) || 0;

      const baseAmount = qty * rate;
      const taxAmount = parseFloat(((baseAmount * tax) / 100).toFixed(2));
      const totalAmount = parseFloat((baseAmount + taxAmount).toFixed(2));

      return {
        ...item,
        baseAmount,
        taxAmount,
        amount: totalAmount,
      };
    });

    setFormData(parsedItems);


    let parsedAdditionalDetails = [];
    try {
      parsedAdditionalDetails = JSON.parse(form.additional_charges || "[]");
    } catch (err) {
      console.log("Invalid JSON for additional_charges:", err);
    }


    setBillDiscountType(form.bill_discount_type || "percent");

    setBillDiscountValue(form.bill_discount_value || 0);

    setBillDiscountAmount(Number(form.bill_discount_amount || 0).toFixed(2));

    recalcTotals(
      parsedItems,
      parsedAdditionalDetails,
      Number(form.bill_discount_value) || 0,
      form.bill_discount_type || "percent"
    );

    const subTotal = parsedItems.reduce(
      (sum, item) => sum + (item.baseAmount || 0),
      0
    );

    const totalGst = parsedItems.reduce(
      (sum, item) => sum + (item.taxAmount || 0),
      0
    );

    const chargesTotal = parsedAdditionalDetails.reduce((sum, item) => {
      const value = Number(item.value2) || 0;
      return item.type?.toLowerCase() === "discount"
        ? sum - value
        : sum + value;
    }, 0);

    const grandTotal = subTotal + totalGst + chargesTotal;


    setSubTotal(subTotal.toFixed(2));
    setTotalTax(totalGst.toFixed(2));
    setGrandTotal(grandTotal.toFixed(2));

    setFormItems({
      id: form.id || "",
      party: form.party || "",
      partyName: form.party_name || "",
      cust_enq: form.cust_enq || "",
      quotation_date: form.quotation_date || "",
      sale_person: form.sale_person || "",
      technician: form.technician || "",
      remark: form.remark || "",
      description: form.description || "",
      ref_doc: form.ref_doc || "",
      type_acc: form.type_acc || "",
      subject: form.subject || "",
      customLetter: form.customLetter || "",
      additionalDetails: parsedAdditionalDetails,
      delivery: form.delivery || " ",
      inv_no: form.inv_no || "",
      branchId: form.branchId || "",

      id: form.id,
      type: form.type || "",
      chargeType:
        form.chargeType ||
        form.charge_type ||
        "amount",
      value1: Number(form.value1) || 0,
      value2: Number(form.value2) || 0,
      gst: Number(form.gst) || 0,
      charge_amount: Number(form.charge_amount) || 0,
      gst_amount: Number(form.gst_amount) || 0,
      taxable: form.taxable ?? false

    });

    setFiles({ file: form.file || null });
    setContent(form.customLetter || "");


    setEditingCompanyId(form.id);
    setShowForm(true);
  };


  // useEffect(() => {
  //   if (formData.length || (formItems?.additionalDetails?.length)) {
  //     recalcTotals(formData, formItems.additionalDetails || []);
  //   }
  // }, [formData, formItems?.additionalDetails]);

  useEffect(() => {
    if (formData.length || formItems?.additionalDetails?.lengt) {
      recalcTotals(
        formData,
        formItems?.additionalDetails || [],
        billDiscountValue,
        billDiscountType
      );
    }
  }, [formData, formItems?.additionalDetails, billDiscountValue, billDiscountType]);


  const companyState = (company?.state || "").trim().toLowerCase();
  const partyState = (selectedParty?.state || "").trim().toLowerCase();

  const isInterState = companyState !== partyState;

  // const recalcTotals = (items = [], extraRows = []) => {

  //   const updatedItems = Array.isArray(items) ? items : [];
  //   const updatedExtra = Array.isArray(extraRows) ? extraRows : [];


  //   const subTotal = updatedItems.reduce(
  //     (sum, item) => sum + (Number(item.baseAmount) || 0),
  //     0
  //   );

  //   const totalGst = updatedItems.reduce(
  //     (sum, item) => sum + (Number(item.taxAmount) || 0),
  //     0
  //   );

  //   // Calculate extra charges / discounts
  //   const chargesTotal = updatedExtra.reduce((sum, item) => {
  //     const value = Number(item.value2) || 0;
  //     return item.type?.toLowerCase() === "discount" ? sum - value : sum + value;
  //   }, 0);

  //   // Grand total
  //   const grandTotal = subTotal + totalGst + chargesTotal;

  //   // Update state
  //   setSubTotal(subTotal.toFixed(2));
  //   setTotalTax(totalGst.toFixed(2));
  //   setGrandTotal(grandTotal.toFixed(2));
  // };



  // const updateRowField = (id, field, value) => {
  //   setFormItems(prev => {
  //     const updated = (prev.additionalDetails || []).map(row => {
  //       if (row.id === id) {
  //         const newRow = { ...row, [field]: value };

  //         // Recalculate value2 if value1 changes
  //         if (field === "value1") {
  //           const numeric = parseFloat(value) || 0;

  //           // Use current subTotal to calculate value2
  //           newRow.value2 = ((numeric * (formData.reduce((sum, item) => sum + (item.baseAmount || 0), 0))) / 100).toFixed(2);
  //         }

  //         return newRow;
  //       }
  //       return row;
  //     });

  //     const newFormItems = { ...prev, additionalDetails: updated };


  //     recalcTotals(formData, updated);

  //     return newFormItems;
  //   });
  // };


  const recalcTotals = (
    items = [],
    extraRows = [],
    billDiscountValue = billDiscountPercent,
    discountType = billDiscountType
  ) => {

    const updatedItems = Array.isArray(items) ? items : [];
    const updatedExtra = Array.isArray(extraRows) ? extraRows : [];

    // 1. Total Item Amount
    const subTotal = updatedItems.reduce((sum, item) => {
      return sum + (Number(item.baseAmount) || 0);
    }, 0);

    // 2. Item Discount
    const totalDiscount = updatedItems.reduce((sum, item) => {
      return sum + (Number(item.discountAmount) || 0);
    }, 0);

    const itemNetAmount = subTotal - totalDiscount;

    // 3. Bill Discount
    let billDiscountAmount = 0;

    if (discountType === "percent") {
      billDiscountAmount =
        (itemNetAmount * Number(billDiscountValue || 0)) / 100;
    } else {
      billDiscountAmount = Number(billDiscountValue || 0);

      if (billDiscountAmount > itemNetAmount) {
        billDiscountAmount = itemNetAmount;
      }
    }

    // 4. Amount after all discounts
    const discountedAmount = itemNetAmount - billDiscountAmount;

    let totalExtraCharges = 0;
    let totalExtraGST = 0;

    updatedExtra.forEach((row) => {

      let chargeAmount = Number(row.value2) || 0;

      if (row.chargeType === "percent") {
        chargeAmount =
          (discountedAmount * chargeAmount) / 100;
      }

      totalExtraCharges += chargeAmount;

      const gstPercent = Number(row.gst) || 0;

      const gstAmount =
        (chargeAmount * gstPercent) / 100;

      totalExtraGST += gstAmount;

    });

    setExtraChargesTotal(totalExtraCharges.toFixed(2));

    let totalGST = 0;

    updatedItems.forEach((item) => {

      const itemAmount =
        Number(item.discountedAmount ?? item.baseAmount) || 0;

      const ratio =
        itemNetAmount > 0
          ? itemAmount / itemNetAmount
          : 0;

      const taxableItemAmount =
        discountedAmount * ratio;

      const gstPercent =
        Number(item.tax) || 0;

      const gst =
        (taxableItemAmount * gstPercent) / 100;

      totalGST += gst;

    });


    let cgst = 0;
    let sgst = 0;
    let igst = 0;

    const finalGST = totalGST + totalExtraGST;

    if (isInterState) {

      igst = finalGST;

    } else {

      cgst = finalGST / 2;
      sgst = finalGST / 2;

    }


    const grandTotal =
      discountedAmount +
      totalExtraCharges +
      totalExtraGST +
      totalGST;

    // const roundOff =
    //     Math.round(grandTotal) - grandTotal;


    setSubTotal(subTotal.toFixed(2));

    setTotalDiscount(totalDiscount.toFixed(2));

    setBillDiscountAmount(billDiscountAmount.toFixed(2));

    setAfterBillDiscountAmount(discountedAmount.toFixed(2));

    setPayableAmount(
      discountedAmount.toFixed(2)
    );

    setCgst(cgst.toFixed(2));
    setSgst(sgst.toFixed(2));
    setIgst(igst.toFixed(2));


    setTotalTax(finalGST.toFixed(2));

    // setGrandTotal(grandTotal.toFixed(2));

    // setRoundOff(roundOff.toFixed(2));

    const roundedGrandTotal = Math.round(grandTotal);

    const roundOff = roundedGrandTotal - grandTotal;

    setGrandTotal(roundedGrandTotal.toFixed(2));
    setRoundOff(roundOff.toFixed(2));

  };

  const updateRowField = (id, field, value) => {
    setFormItems(prev => {
      const updated = (prev.additionalDetails || []).map(row => {
        if (row.id === id) {
          const newRow = { ...row, [field]: value };

          // Recalculate value2 if value1 changes
          if (field === "value1") {
            const numeric = parseFloat(value) || 0;

            // Use current subTotal to calculate value2
            newRow.value2 = ((numeric * (formData.reduce((sum, item) => sum + (item.baseAmount || 0), 0))) / 100).toFixed(2);
          }

          return newRow;
        }
        return row;
      });

      const newFormItems = { ...prev, additionalDetails: updated };


      recalcTotals(formData, updated, billDiscountValue, billDiscountType);

      return newFormItems;
    });
  };

  const fecthDetail = async () => {
    setLoading(true);
    try {
      const resInventory = await axios.get('https://api.skyguard.group/api/fetch-inventory');
      const items = resInventory.data.result || [];
      setItems(items);
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };

  const fetchPartyDetail = async () => {
    setLoading(true)
    try {
      const resParty = await axios.get("https://api.skyguard.group/api/fetch-party-bill");

      const options = resParty.data.map((p) => ({
        value: p.id,
        label: p.name,
        phone: p.phone,
        address: p.address,
        state: p.state
      }));

      const data = resParty.data;

      setDetail(data);

      setPartyOptions(options);

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const fectEmphDetail = async () => {
    setLoading(true)
    try {
      const resEmployee = await axios.get('https://api.skyguard.group/api/fetch-employee');
      const filtered = (resEmployee.data.result || []).filter(
        emp => emp.emp_id !== null && emp.emp_id !== undefined && emp.emp_id !== ""
      );

      setUser(filtered);
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };

  const fetchSaleQuotation = async (fromDate,
    toDate,
    branchCode,
    newOffset = 0) => {
    setLoading(true)

    if (!branchCode) {
      console.log("Branch code missing");
      return;
    }
    try {
      const response = await axios.get('https://api.skyguard.group/api/fetch-sale-quotation',
        {
          params: {
            from_date: fromDate,
            to_date: toDate,
            branch_code: branchCode,
            limit: limit,
            offset: newOffset
          }
        }
      );
      // setQuotation(response.data);

      const result = response.data;
      if (newOffset === 0) {
        setQuotation(result);
        setHasMore(true);
      }

      else {
        setQuotation(prev => {
          const merged = [...prev, ...result];

          // optional: remove duplicates (safety)
          const unique = Array.from(
            new Map(merged.map(item => [item.id, item])).values()
          );

          return unique;
        });
      }

      // check if more data exists
      if (result.length < limit) {
        setHasMore(false);
      }

    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };

  const fetchChargeDetail = async () => {
    setLoading(true)
    try {
      const response = await axios.get('https://api.skyguard.group/api/fetch-master-charge');
      setChargeMaster(response.data);
      const options = response.data.map((item) => ({
        value: item.charge_name,
        label: item.charge_name
      }));

      setChargeOptions(options);

    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };



  const fetchBranchDetail = async () => {
    setLoading(true)
    try {
      const branchRes = await axios.get(`https://api.skyguard.group/api/fetch-branch-localData/${branchID}`);
      setBranchDetail(branchRes.data)
      return branchRes.data.code;
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };


  const fetchYearDetail = async () => {
    setLoading(true);
    try {
      const branchCode = await fetchBranchDetail();
      const res = await axios.get(
        `https://api.skyguard.group/api/fetch-financial-year-localData/${financialYear}`
      );
      const yearData = res.data;
      setFy(yearData);
      // setIsLocked(yearData.is_locked === 1);

      setValidUpto(yearData.valid_up_to);
      let shouldLock = false;

      // First check is_locked
      if (Number(yearData.is_locked) === 1) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const validUptoDate = new Date(yearData.valid_up_to);
        validUptoDate.setHours(0, 0, 0, 0);

        // Lock only if valid_up_to date has passed
        shouldLock = validUptoDate <= today;
      }

      setIsLocked(shouldLock);

      setFinancialRange({
        from_date: yearData.from_date,
        to_date: yearData.to_date
      });

      await fetchSaleQuotation(
        yearData.from_date,
        yearData.to_date,
        branchCode,

      );
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const isVoucherLocked = (paymentDate) => {
    if (!validUpto || !paymentDate) return false;

    const voucherDate = new Date(paymentDate);
    voucherDate.setHours(0, 0, 0, 0);

    const fyValidUpto = new Date(validUpto);
    fyValidUpto.setHours(0, 0, 0, 0);

    return voucherDate <= fyValidUpto;
  };

  const fetchCompany = async () => {
    setLoading(true)
    try {
      const res = await axios.get(`https://api.skyguard.group/api/fetch-company-localData/${companyID}`);
      setCompany(res.data);

    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {

    fecthDetail();
    fetchPartyDetail();
    fectEmphDetail();

    fetchChargeDetail();
    fetchBranchDetail();
    fetchYearDetail();
    fetchCompany();
  }, []);



  const handleUpdate = async (e) => {
    e.preventDefault();

    const sendData = new FormData();
    const safe = (v) => (v === undefined || v === null ? "" : v);

    // Basic fields
    sendData.append("type_acc", "sale_quotation");
    sendData.append("cust_enq", formItems.cust_enq);
    sendData.append(
      "quotation_date",
      formItems.quotation_date || new Date().toISOString().split("T")[0]
    );
    sendData.append("sale_person", formItems.sale_person);
    sendData.append("technician", formItems.technician);
    sendData.append("remark", safe(formItems.remark));
    sendData.append("description", safe(formItems.description));
    sendData.append("grand_total", grandTotal);
    sendData.append("total_gst", totalTax);
    sendData.append("sub_total", subTotal);
    sendData.append("ref_doc", formItems.ref_doc);
    sendData.append("customLetter", content);
    sendData.append("subject", formItems.subject);
    sendData.append("party", formItems.party);
    sendData.append("branchId", branchDetail.code);
    sendData.append("delivery", formItems.delivery);


    sendData.append("taxable_amount", payableAmount);
    sendData.append("cgst", cgst);
    sendData.append("sgst", sgst);
    sendData.append("igst", igst);
    sendData.append("round_off", roundOff);
    sendData.append("is_inter_state", isInterState ? 1 : 0);
    sendData.append("bill_discount_type", billDiscountType);
    sendData.append("bill_discount_value", billDiscountValue);
    sendData.append("bill_discount_amount", billDiscountAmount);
    sendData.append("discounted_taxable_amount", payableAmount);
    sendData.append("gst_amount", totalTax);
    sendData.append("extra_charges_total", extraChargesTotal);

    // Items table
    // sendData.append(
    //   "items",
    //   JSON.stringify(
    //     (formData || []).map((item) => {
    //       const qty = parseFloat(item.qty) || 0;
    //       const rate = parseFloat(item.rate) || 0;
    //       const tax = parseFloat(item.tax) || 0;
    //       const baseAmount = qty * rate;
    //       const gstAmount = parseFloat(((baseAmount * tax) / 100).toFixed(2));
    //       const amount = parseFloat((baseAmount + gstAmount).toFixed(2));

    //       return {
    //         id: item.id || null,
    //         name: item.name,
    //         qty,
    //         rate,
    //         tax,
    //         gst_amount: gstAmount,
    //         base_amount: baseAmount,
    //         amount,
    //       };
    //     })
    //   )
    // );
    const validItems = formData
      .filter(item => item.name && item.name.trim() !== "")
      .map(item => {

        const qty = Number(item.qty) || 0;
        const rate = Number(item.rate) || 0;
        const gstPercent = Number(item.tax) || 0;
        const discountPercent = Number(item.discount) || 0;
        const baseAmount = qty * rate;
        const discountAmount = Number(
          ((baseAmount * discountPercent) / 100).toFixed(2)
        );
        const taxableAmount = baseAmount - discountAmount;
        const gstAmount = Number(
          ((taxableAmount * gstPercent) / 100).toFixed(2)
        );
        const totalAmount = Number(
          (taxableAmount + gstAmount).toFixed(2)
        );


        return {
          id: item.id,
          name: item.name,
          qty,
          rate,
          baseAmount,
          tax: gstPercent,
          hsn: item.hsn || "",

          // discount details
          discount: discountPercent,
          discountAmount,
          taxableAmount,

          gstAmount,
          totalAmount
        };
      });

    sendData.append("items", JSON.stringify(validItems));




    // Additional Charges (safe)
    // sendData.append(
    //   "additional_charges",
    //   JSON.stringify(
    //     (formItems.additionalDetails || []).map((row) => ({
    //       id: row.id || null,
    //       type: row.type,
    //       value1: Number(row.value1) || 0,
    //       value2: Number(row.value2) || 0,
    //     }))
    //   )
    // );



    sendData.append(
      "additional_charges",
      JSON.stringify(
        (formItems.additionalDetails || []).map((row) => {

          let chargeAmount = Number(row.value2) || 0;

          if (row.chargeType === "percent") {
            chargeAmount =
              (Number(payableAmount) * chargeAmount) / 100;
          }

          const gstPercent = Number(row.gst) || 0;

          const gstAmount =
            (chargeAmount * gstPercent) / 100;

          return {
            id: row.id || null,

            type: row.type,

            charge_type: row.chargeType || "amount",

            value1: Number(row.value1) || 0,

            value2: Number(row.value2) || 0,

            // Actual charge amount
            charge_amount: Number(chargeAmount.toFixed(2)),

            // GST Percentage
            gst: gstPercent,

            // GST Amount
            gst_amount: Number(gstAmount.toFixed(2)),

            taxable: false
          };

        })
      )
    );

    // File upload
    if (files.file) sendData.append("file", files.file);

    try {
      let res;

      if (isEditMode && editingCompanyId) {
        sendData.append("edit_by", adminData.user.id);

        res = await axios.put(
          `https://api.skyguard.group/api/update-sale-quotation/${editingCompanyId}`,
          sendData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        showToast("Sale Quotation Updated Successfully!", "success");
        fetchSaleQuotation(financialRange.from_date,
          financialRange.to_date,
          branchDetail.code,
          0);
      } else {
        sendData.append("added_by", adminData.user.id);

        res = await axios.post(
          "https://api.skyguard.group/api/add-sale-quotation",
          sendData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        showToast("Sale Quotation Added Successfully!", "success");
        fetchSaleQuotation(financialRange.from_date,
          financialRange.to_date,
          branchDetail.code,
          0);
      }

      resetForm();
    } catch (err) {
      console.error("❌ Error:", err.response?.data || err.message);
      showToast(
        isEditMode ? "Failed to update!" : "Failed to create!",
        "danger"
      );
    }
  };


  const resetForm = () => {
    setFormItems({
      party: "",
      cust_enq: "",
      quotation_date: getTodayDateTime(),
      sale_person: "",
      technician: "",
      grand_total: "",
      total_gst: "",
      sub_total: "",
      remark: 'By using this service, you agree to the terms and conditions.',
      description: "",
      ref_doc: "",
      type_acc: "",
      subject: '',
      customLetter: null,
      delivery: '',
    });

    setFormData([]);
    setSelectedDoc(null);
    setSelectedParty(null);
    setSubTotal("0.00");
    setTotalTax("0.00");
    setGrandTotal("0.00");
    setFiles({});
    setShowForm(false);
    setContent("");
    setBillDiscountType([]);
    setBillDiscountValue([]);
  };

  const filterQuotation = quotation.filter((tt) => {
    const term = searchTerm.toLowerCase();

    return (
      (tt.party_name && tt.party_name.toLowerCase().includes(term))

    );
  });




  const exportInvoiceToPDF = (selectedQuotation) => {
    const doc = new jsPDF("p", "mm", "a4");

    /* ================= HEADER ================= */
    doc.setFontSize(16);
    doc.setTextColor(0);
    doc.text("STAR SIGNATURE SERVICES", 105, 16, { align: "center" });

    doc.setFontSize(10);

    const addressText =
      "A-8 JAI ISH KRUPA CHS LTD. ANAND NAGAR OPP AL-NOOR MASZID VASAI W 401202 THANE MUMBAI MAHARASHTRA";

    const addressLines = doc.splitTextToSize(addressText, 180);
    doc.text(addressLines, 105, 22, { align: "center" });

    let currentY = 22 + addressLines.length * 5;

    doc.text(
      "BRANCH: DADAR | THANE | PUNE | AURANGABAD | GOA PANJIM",
      105,
      currentY,
      { align: "center" }
    );

    currentY += 6;

    const contactLines = doc.splitTextToSize(
      "Phone: 9209206677, 9209203355, 9324004632 | Email: starsignatureservices@gmail.com",
      180
    );
    doc.text(contactLines, 105, currentY, { align: "center" });

    currentY += contactLines.length * 5;

    doc.text("GSTIN: 27ADYPY53133M2ZH", 105, currentY + 2, {
      align: "center"
    });

    doc.setFontSize(12);
    doc.text("SALE QUOTATION", 105, currentY + 10, { align: "center" });

    /* ================= BILL TO / INVOICE ================= */
    autoTable(doc, {
      startY: currentY + 15,
      theme: "grid",
      styles: { fontSize: 9 },
      headStyles: {
        // fillColor: [255, 255, 255], // white header
        textColor: 0,
        fontStyle: "bold"
      },
      head: [["Bill To", "Invoice Details"]],
      body: [
        [
          `Party Name: ${selectedQuotation.party_name}
Customer Enquiry: ${selectedQuotation.cust_enq || "-"}
Contact: ${selectedQuotation.party_phone}
Address: ${selectedQuotation.party_address}`,

          `Invoice No: ${selectedQuotation.invoice_no || "-"}
Date: ${selectedQuotation.quotation_date}
Sale Person: ${selectedQuotation.sale_emp_first} ${selectedQuotation.sale_emp_middle || ""} ${selectedQuotation.sale_emp_last}
Technician: ${selectedQuotation.tech_emp_first || ""} ${selectedQuotation.tech_emp_middle || ""} ${selectedQuotation.tech_emp_last || ""}`
        ]
      ]
    });

    /* ================= ITEMS TABLE ================= */
    const items = selectedQuotation.items
      ? JSON.parse(selectedQuotation.items)
      : [];

    const itemRows = items.map((item, index) => [
      index + 1,
      item.name,
      item.qty,
      item.rate,
      item.tax,
      item.amount
    ]);

    autoTable(doc, {
      startY: doc.lastAutoTable.finalY + 8,
      theme: "grid",
      styles: { fontSize: 9 },
      headStyles: {
        // fillColor: [255, 255, 255], // 🔥 removes grey
        textColor: 0,
        fontStyle: "bold"
      },
      head: [["#", "Item Name", "Qty", "Rate", "GST %", "Amount"]],
      body: itemRows
    });

    /* ================= TOTALS ================= */
    autoTable(doc, {
      startY: doc.lastAutoTable.finalY + 5,
      theme: "grid",
      styles: { fontSize: 10 },
      body: [
        ["Total GST", selectedQuotation.total_gst],
        ["Sub Total", selectedQuotation.sub_total],
        ["Grand Total", selectedQuotation.grand_total]
      ],
      columnStyles: {
        0: { halign: "right", fontStyle: "bold" },
        1: { halign: "right" }
      }
    });

    /* ================= FOOTER ================= */
    let footerY = doc.lastAutoTable.finalY + 8;

    if (selectedQuotation.description) {
      doc.text(`Description: ${selectedQuotation.description}`, 14, footerY);
      footerY += 6;
    }

    if (selectedQuotation.remark) {
      doc.text(`Remark: ${selectedQuotation.remark}`, 14, footerY);
    }

    doc.save(`Invoice_${selectedQuotation.invoice_no || "NA"}.pdf`);
  };



  // const handlePrint = () => {
  //   const printContents = document.getElementById("invoice-print-area").innerHTML;
  //   const originalContents = document.body.innerHTML;

  //   // Open a new window for printing
  //   const printWindow = window.open("", "_blank", "width=900,height=600");
  //   printWindow.document.write(`
  //   <html>
  //     <head>
     
  //       <style>
  //         body { font-family: Arial, sans-serif; margin: 20px; }
  //         table { border-collapse: collapse; width: 100%; }
  //         table, th, td { border: 1px solid #000; }
  //         th, td { padding: 5px; text-align: center; }
  //         .text-start { text-align: left; }
  //       </style>
  //     </head>
  //     <body>
  //       ${printContents}
  //     </body>
  //   </html>
  // `);

  //   printWindow.document.close();
  //   printWindow.focus();
  //   printWindow.print();
  //   printWindow.close();
  // };


      const handlePrint = () => {
        const printContents = document.getElementById("invoice-print-area");

        const printWindow = window.open("", "_blank");

        printWindow.document.write(`
    <html>
      <head>
        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"/>
        <style>
          body { margin: 10px; }
        </style>
      </head>
      <body></body>
    </html>
  `);

        printWindow.document.close();

        const clonedContent = printContents.cloneNode(true);
        printWindow.document.body.appendChild(clonedContent);

        printWindow.focus();
        printWindow.print();
        printWindow.close();
    };

  const handleLoadMore = () => {

    const nextOffset = offset + limit;
    setOffset(nextOffset);

    fetchSaleQuotation(
      financialRange.from_date,
      financialRange.to_date,
      branchDetail.code,
      nextOffset
    );
  };

  
     const thStyle = {
        border: "1px solid #000",
        padding: "8px",
        textAlign: "center",
        fontWeight: "bold",
    };

    const tdCenter = {
        border: "1px solid #000",
        padding: "6px",
        textAlign: "center",
    };

    const tdLeft = {
        border: "1px solid #000",
        padding: "6px",
        textAlign: "left",
    };

    const tdRight = {
        border: "1px solid #000",
        padding: "6px",
        textAlign: "right",
    };
    const summaryTitle = {
        border: "1px solid #000",
        padding: "8px",
        fontWeight: "bold",
    };

    const summaryValue = {
        border: "1px solid #000",
        padding: "8px",
        textAlign: "right",
    };


    const bankTitle = {
        border: "1px solid #000",
        padding: "8px",
        fontWeight: "bold",
        width: "35%",
    };

    const bankValue = {
        border: "1px solid #000",
        padding: "8px",
    };


  return (
    <>
      <div className='main-section'>
        <ToastNotification
          show={toast.show}
          message={toast.message}
          bg={toast.bg}
          onClose={() => setToast({ ...toast, show: false })}
        />
        <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
          <h3 className='my-3 fw-bold fs-5 golos'>Sale Quotation</h3>

          <div class="mb-3 row gx-3 gy-2 align-items-center  d-flex justify-content-between">
            <div class="col-12 col-md-4">
              <input
                type="text"
                class="form-control"
                placeholder="Search by Party Name..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-2 d-flex justify-content-end">
              <button
                className={`btn ${showForm ? 'btn-danger' : 'btn-success'}`}
                onClick={() => {
                  setShowForm(prev => !prev);

                  if (showForm) {
                    setIsEditMode(false);
                    setEditingCompanyId(null);
                    resetForm();
                  }
                }}
              >
                {showForm ? (
                  <>
                    Close <FaTimes size={18} />
                  </>
                ) : (
                  <>
                    Add <AiOutlinePlusCircle size={18} />
                  </>
                )}
              </button>
            </div>
          </div>


          {showForm && (


            <fieldset >
              <form onSubmit={handleUpdate}>


                <div className='card p-3 my-3 shadow-sm bg-white border'>
                  <div className='row'>

                    <div className='col-12'>
                      {isEditMode && (
                        <div className="mb-3">
                          <label>Document No:</label> <br />
                          <span className="badge bg-primary px-3 py-2">
                            {`SQ/${formItems.inv_no}/${formItems.branchId}`}
                          </span>
                        </div>
                      )}

                      <div className='row g-3'>

                        <div className="col-12 col-md-4">
                          <label htmlFor="party" className="form-label fw-medium">Select Party</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Choose Party..."
                            value={formItems.partyName || ""}
                            readOnly
                            onClick={() => setShowPartyModal(true)}
                            required
                            disabled={isEditMode && isLocked}
                          />

                          <Modal show={showPartyModal} onHide={() => setShowPartyModal(false)} size="lg">
                            <Modal.Header closeButton>
                              <Modal.Title>Search Party</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                              <Form.Control
                                type="text"
                                placeholder="Search by name, phone, or address"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                ref={searchInputRef}
                              />
                              <div className="table-responsive mt-3">
                                <Table striped bordered hover className="mt-3">
                                  <thead>
                                    <tr>
                                      <th>Action</th>
                                      <th>Name</th>
                                      <th>Phone</th>
                                      <th>Address</th>

                                    </tr>
                                  </thead>
                                  <tbody>
                                    {filtered.map((p) => (
                                      <tr key={p.value}>
                                        <td className="text-center" style={{ width: "80px" }}>
                                          <Button
                                            variant="primary"
                                            size="sm"
                                            onClick={() => {
                                              setSelectedParty(p);
                                              setFormItems((prev) => ({
                                                ...prev,
                                                party: p.value,
                                                partyName: p.label,
                                                delivery: p.address,
                                              }));
                                              setShowPartyModal(false);
                                              setUseDefaultShipping(true);
                                            }}
                                          >
                                            Select
                                          </Button>
                                        </td>
                                        <td>{p.label}</td>
                                        <td>{p.phone}</td>
                                        <td style={{ maxWidth: "300px", whiteSpace: "normal", overflow: "hidden", textOverflow: "ellipsis" }}>
                                          {(p.address || "").length > 50 ? `${(p.address || "").slice(0, 50)}...` : (p.address || "NA")}
                                        </td>

                                      </tr>
                                    ))}
                                  </tbody>
                                </Table>
                              </div>

                            </Modal.Body>
                          </Modal>
                        </div>

                        <div className="col-12 col-md-4">
                          <label className="form-label fw-medium">Customer Reference No.</label>
                          <input
                            type="text"
                            className="form-control"
                            name="cust_enq"
                            value={formItems.cust_enq}
                            onChange={handleChange}
                            disabled={isEditMode && isLocked}
                          />
                        </div>



                        <div className="col-12 col-md-4">
                          <label className="form-label fw-medium">Quotation Date & Time</label>
                          <input
                            type="datetime-local"
                            className="form-control"
                            name="quotation_date"
                            value={
                              formItems.quotation_date}
                            onChange={handleChange}
                            disabled={isEditMode && isLocked}
                          />
                        </div>


                        <div className="col-12 col-sm-12 col-md-4">
                          <label className="form-label fw-medium">Sale Person</label>
                          <Select
                            options={user.map((t) => ({
                              value: t.id,
                              label: `${t.first} ${t.last} (${t.emp_id})`,
                            }))}


                            value={
                              user
                                .map((t) => ({
                                  value: t.id,
                                  label: `${t.first} ${t.last} (${t.emp_id})`,
                                }))
                                .find((opt) => opt.value == formItems.sale_person) || null
                            }
                            onChange={(e) =>
                              handleChange({ target: { name: "sale_person", value: e.value } })
                            }
                            className="w-100"
                            menuPlacement="auto"
                            isDisabled={isEditMode && isLocked}
                          />

                        </div>

                        <div className="col-12 col-sm-12 col-md-4">
                          <label className="form-label fw-medium">Technician</label>

                          <Select
                            options={user.map((t) => ({
                              value: t.id,
                              label: `${t.first} ${t.last} (${t.emp_id})`,
                            }))}

                            /* 🔥 ADD THIS */
                            value={
                              user
                                .map((t) => ({
                                  value: t.id,
                                  label: `${t.first} ${t.last} (${t.emp_id})`,
                                }))
                                .find((opt) => opt.value == formItems.technician) || null
                            }

                            onChange={(e) =>
                              handleChange({ target: { name: "technician", value: e.value } })
                            }
                            className="w-100"
                            menuPlacement="auto"
                            isDisabled={isEditMode && isLocked}
                          />


                        </div>



                        <div className="col-12 col-md-4">
                          <div className="d-flex align-items-center gap-2 text-nowrap">
                            <label htmlFor="delivery" className="fw-medium mb-0">
                              Shipping Address
                            </label>

                            <input
                              type="checkbox"
                              className="form-check-input m-0"
                              id="editShipping"
                              checked={!useDefaultShipping}
                              onChange={() => setUseDefaultShipping(!useDefaultShipping)}
                              disabled={isEditMode && isLocked}
                            />

                            <span className="text-muted">Change Address</span>
                          </div>

                          <input
                            type="text"
                            className="form-control mt-1"
                            id="delivery"
                            name="delivery"
                            value={formItems.delivery || ""}
                            onChange={handleChange}
                            disabled={useDefaultShipping}
                            disabled={isEditMode && isLocked}
                          />
                        </div>

                        <div className="col-12 col-md-4">
                          <label className="form-label fw-medium">Items:</label>

                          <Select
                            options={items.map((t) => ({
                              value: t.id,
                              label: `${t.name} (${t.stock} | ${t.category})`,
                            }))}

                            value={
                              selectedItemId
                                ? (() => {
                                  const item = items.find((i) => i.id === selectedItemId);

                                  return item
                                    ? {
                                      value: item.id,
                                      label: `${item.name} (${item.stock}) | ${item.category} | ${item.group_item}`,
                                    }
                                    : null;
                                })()
                                : null
                            }

                            onChange={(e) =>
                              handleSelectChange({
                                target: { name: "emp_id", value: e?.value || "" },
                              })
                            }

                            className="w-100"
                            menuPlacement="auto"
                            isDisabled={isEditMode && isLocked}
                          />
                        </div>

                        <div className="col-12 col-md-4">
                          <label className="form-label fw-medium">Add Item</label> <br />
                          <button className="btn btn-primary"
                            onClick={() => {
                              navigate("/admin/inventory", {
                                state: {
                                  showAddForm: true,

                                }
                              });
                            }}
                          >
                            Add New Item
                          </button>
                        </div>

                      </div>
                    </div>

                    <div className="col-12 mt-3">
                      {/* <div className="table-responsive">
                      <table className="table table-bordered text-center align-middle">
                        <thead className="table-primary">
                          <tr>
                            <th>Item Name</th>
                            <th>Quantity</th>
                            <th> Sale Rate</th>
                            <th>Item GST</th>
                            <th>Amount</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {formData.length === 0 ? (
                            <tr>
                              <td colSpan="6" className="text-center text-muted">
                                Select an item from the dropdown to add here
                              </td>
                            </tr>
                          ) : (
                            formData.map((fi, idx) => (
                              <tr key={idx}>
                                <td><input type="text" className="form-control" value={fi.name} onChange={(e) => handleFormItemChange(idx, "name", e.target.value)}    disabled={isEditMode && isLocked} /></td>
                                <td><input type="number" className="form-control" value={fi.qty} onChange={(e) => handleFormItemChange(idx, "qty", e.target.value)}    disabled={isEditMode && isLocked}/></td>
                                <td><input type="number" className="form-control" value={fi.rate} onChange={(e) => handleFormItemChange(idx, "rate", e.target.value)}    disabled={isEditMode && isLocked}/></td>


                                <td>
                                  <select
                                    className="form-control"
                                    value={fi.tax}
                                    onChange={(e) => handleGstChange(e.target.value, idx)}
                                       disabled={isEditMode && isLocked}
                                  >

                                    <option value={fi.tax}> {fi.tax} </option>


                                    <option disabled>──────────</option>


                                    <option value="0%">0%</option>
                                    <option value="5%">5%</option>
                                    <option value="12%">12%</option>
                                    <option value="18%">18%</option>
                                    <option value="28%">28%</option>
                                  </select>
                                </td>





                                <td><input type="text" className="form-control" value={fi.amount || ""} readOnly    disabled={isEditMode && isLocked}/></td>
                                <td>
                                  <button className="btn btn-danger" onClick={() => handleDeleteItem(idx)}    disabled={isEditMode && isLocked}>Delete</button>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                        <tfoot>
                        


                          <tr>
                            <td colSpan="3" className="text-end fw-bold">Total GST</td>
                            <td><input type="text" value={totalTax} readOnly className="form-control" /></td>
                            <td className="text-end fw-bold">SUB Total</td>
                            <td><input type="text" value={subTotal} readOnly className="form-control" /></td>
                          </tr>

                       

                             <tr className="text-end fw-bold">
                            <td colSpan="6">
                              <div className="d-flex justify-content-end mb-2">
                                <button
                                  type="button"
                                  className="btn btn-primary btn-sm"
                                  onClick={addRow}
                                     disabled={isEditMode && isLocked}
                                >
                                  + Add Row
                                </button>
                              </div>
                            </td>
                          </tr>

                          {formItems.additionalDetails?.map((row,index) => (
                            <tr key={row.id || index}>
                              <td colSpan="6">
                                <div className="d-flex justify-content-end align-items-center gap-2">
                                  <Select
                                    options={chargeOptions}
                                    value={chargeOptions.find(option => option.value === row.type)}
                                    onChange={(selected) => {

                                      const selectedCharge = chargeMaster.find(
                                        (item) => item.charge_name === selected.value
                                      );

                                    
                                        updateRowField(row.id, "type", selected.value);


                                      if (selectedCharge) {
                                        updateRowField(row.id, "value1", selectedCharge.charge_mrp);
                                      }
                                    }}
                                    placeholder="Select Charge"
                                    hideSelectedOptions={false}
                                
                                      menuPortalTarget={document.body}
                                styles={{
                                  container: base => ({ ...base, width: 150 }),
                                  menuPortal: base => ({ ...base, zIndex: 9999 })
                                }}
                                isDisabled={isEditMode && isLocked}
                                  />


                                  <input
                                    type="text"
                                    className="form-control"
                                    style={{ width: "120px" }}
                                    value={row.value1 || ""}
                               
                                    onChange={(e) => updateRowField(row.id, "value1", e.target.value)}
                                       disabled={isEditMode && isLocked}
                                  />

                                  <input
                                    type="text"
                                    className="form-control"
                                    style={{ width: "120px" }}
                                    value={row.value2 || ""}
                              
                                     onChange={(e) => updateRowField(row.id, "value2", e.target.value)}
                                        disabled={isEditMode && isLocked}
                                  />

                                 
                                  <button className="btn btn-danger btn-sm" onClick={() => deleteRow(index)}    disabled={isEditMode && isLocked}>

                                  <MdDeleteForever size={20} />
                                  </button>
                                </div>
                              </td>
                            </tr>

                          ))}



                          <tr>
                            <td colSpan="5" className="text-end fw-bold">Grand Total</td>
                            <td>
                              <input type="text"  
                             value={grandTotal} 
                             
                             readOnly className="form-control" />
 

                             </td>
 
                          </tr>



                        </tfoot>
                      </table>
                    </div> */}

                      <div className="table-responsive my-4">
                        <h5 className='golos'>Add New Item</h5>
                        <table className="table table-bordered text-center align-middle">
                          <thead className="table-primary">
                            <tr>
                              <th style={{ width: "220px" }}>Item Name</th>
                              <th style={{ width: "80px" }}>Qty</th>
                              <th style={{ width: "120px" }}>Rate</th>
                              <th style={{ width: "80px" }}> Discount</th>
                              <th style={{ width: "100px" }}>GST</th>
                              <th style={{ width: "120px" }}>Tax Amount</th>
                              <th style={{ width: "80px" }}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {formData.map((fi, idx) => (
                              <tr key={idx}>
                                <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={fi.name}
                                    onChange={(e) => handleFormItemChange(idx, 'name', e.target.value)}
                                    placeholder="Item Name"
                                    disabled={isEditMode && isLocked}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    className="form-control "
                                    value={fi.qty}
                                    onChange={(e) => handleFormItemChange(idx, 'qty', e.target.value)}
                                    placeholder="Qty"
                                    disabled={isEditMode && isLocked}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    className="form-control"
                                    value={fi.rate}
                                    onChange={(e) => handleFormItemChange(idx, 'rate', e.target.value)}
                                    placeholder="Rate"
                                    disabled={isEditMode && isLocked}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    className="form-control"
                                    value={fi.discount || ""}
                                    placeholder="%"
                                    onChange={(e) =>
                                      handleFormItemChange(idx, "discount", e.target.value)
                                    }
                                    disabled={isEditMode && isLocked}
                                  />
                                </td>

                                <td>
                                  <select
                                    className="form-control"
                                    value={fi.tax}
                                    onChange={(e) => handleGstChange(+e.target.value, idx)}
                                    disabled={isEditMode && isLocked}
                                  >
                                    <option value={0}>0%</option>
                                    <option value={0.25}>0.25%</option>
                                    <option value={3}>3%</option>
                                    <option value={5}>5%</option>
                                    <option value={12}>12%</option>
                                    <option value={18}>18%</option>
                                    <option value={28}>28%</option>
                                  </select>

                                </td>



                                <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={fi.amount || ''}
                                    readOnly
                                    disabled={isEditMode && isLocked}
                                  />
                                </td>


                                <td>
                                  <button className="btn btn-danger btn-sm" onClick={() => handleDeleteItem(idx)} disabled={isEditMode && isLocked}>


                                    <MdDeleteForever size={15} />
                                  </button>
                                </td>

                              </tr>
                            ))}
                          </tbody>
                          <tfoot>

                            <tr>

                            </tr>

                            <tr>
                              <td colSpan="6" className="text-end fw-bold">
                                Total Item Amount
                              </td>
                              <td>
                                <input
                                  className="form-control"
                                  value={subTotal}
                                  readOnly
                                />
                              </td>
                            </tr>


                            <tr>
                              <td colSpan="5" className="text-end fw-bold">
                                Bill Discount
                              </td>

                              <td>
                                <select
                                  className="form-select"
                                  value={billDiscountType || "percent"}
                                  onChange={(e) => {

                                    const type = e.target.value;

                                    setBillDiscountType(type);

                                    recalcTotals(
                                      formData,
                                      formItems?.additionalDetails || [],
                                      billDiscountValue || 0,
                                      type
                                    );

                                  }}
                                  disabled={isEditMode && isLocked}
                                >
                                  <option value="percent">%</option>
                                  <option value="amount">Amount</option>
                                </select>
                              </td>


                              <td>
                                <input
                                  type="number"
                                  className="form-control"
                                  value={billDiscountValue ?? ""}
                                  onChange={(e) => {

                                    const value = e.target.value;

                                    setBillDiscountValue(value);

                                    recalcTotals(
                                      formData,
                                      formItems?.additionalDetails || [],
                                      value || 0,
                                      billDiscountType || "percent"
                                    );

                                  }}
                                  disabled={isEditMode && isLocked}
                                />
                              </td>
                            </tr>

                            <tr>
                              <td colSpan="6" className="text-end fw-bold">
                                Taxable Amount
                              </td>
                              <td>
                                <input
                                  className="form-control"
                                  value={payableAmount}
                                  readOnly
                                />
                              </td>
                            </tr>








                            <tr className="text-end fw-bold">
                              <td colSpan="7">
                                <div className="d-flex justify-content-end mb-2">
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    onClick={addRow}
                                    disabled={isEditMode && isLocked}
                                  >
                                    + Add Row
                                  </button>
                                </div>
                              </td>
                            </tr>

                            {formItems.additionalDetails?.map((row, index) => (
                              <tr key={row.id || index}>
                                <td colSpan="7">
                                  <div className="d-flex justify-content-end align-items-center gap-2">
                                    <Select
                                      options={chargeOptions}
                                      value={chargeOptions.find(option => option.value === row.type)}
                                      onChange={(selected) => {

                                        const selectedCharge = chargeMaster.find(
                                          (item) => item.charge_name === selected.value
                                        );
                                        updateRowField(row.id, "type", selected.value);
                                        if (selectedCharge) {
                                          updateRowField(row.id, "value1", selectedCharge.charge_mrp);
                                        }
                                      }}
                                      placeholder="Select Charge"
                                      hideSelectedOptions={false}
                                      menuPortalTarget={document.body}
                                      styles={{
                                        container: base => ({ ...base, width: 150 }),
                                        menuPortal: base => ({ ...base, zIndex: 9999 })
                                      }}
                                      isDisabled={isEditMode && isLocked}
                                    />
                                    <select
                                      className="form-select w-auto"
                                      style={{ minWidth: "120px" }}

                                      value={row.chargeType || "amount"}
                                      onChange={(e) =>
                                        updateRowField(
                                          row.id,
                                          "chargeType",
                                          e.target.value
                                        )
                                      }
                                    >
                                      <option value="amount">
                                        Amount
                                      </option>

                                      <option value="percent">
                                        %
                                      </option>

                                    </select>



                                    <input
                                      type="text"
                                      className="form-control"
                                      style={{ width: "120px" }}
                                      value={row.value2 || ""}

                                      onChange={(e) => updateRowField(row.id, "value2", e.target.value)}
                                      disabled={isEditMode && isLocked}
                                    />


                                    <select
                                      className="form-select w-auto"
                                      style={{ minWidth: "90px" }}
                                      value={row.gst || 0}
                                      onChange={(e) =>
                                        updateRowField(row.id, "gst", Number(e.target.value))
                                      }
                                      disabled={isEditMode && isLocked}
                                    >
                                      <option value={0}>0%</option>
                                      <option value={0.25}>0.25%</option>
                                      <option value={3}>3%</option>
                                      <option value={5}>5%</option>
                                      <option value={12}>12%</option>
                                      <option value={18}>18%</option>
                                      <option value={28}>28%</option>
                                    </select>


                                    <button className="btn btn-danger btn-sm" onClick={() => deleteRow(index)} disabled={isEditMode && isLocked}>

                                      <MdDeleteForever size={20} />
                                    </button>
                                  </div>
                                </td>
                              </tr>

                            ))}


                            <tr>
                              <td colSpan="6" className="text-end fw-bold">
                                Total GST
                              </td>
                              <td>
                                <input value={totalTax} readOnly className="form-control" />
                              </td>

                            </tr>

                            <tr>
                              <td colSpan="6" className="text-end fw-bold">
                                Grand Total
                              </td>
                              <td>
                                <input
                                  className="form-control"
                                  value={grandTotal}
                                  readOnly
                                />
                              </td>
                            </tr>

                          </tfoot>
                        </table>

                      </div>
                    </div>


                    <div className='col-12 col-md-6 p-3'>
                      <label className='form-label fw-medium'>Attachment</label>
                      <input type="file" className="form-control" name='file' accept="image/*,application/pdf" onChange={handleFileChange} disabled={isEditMode && isLocked} />
                      {isEditMode && files.file && typeof files.file === "string" && (
                        <div className="mt-2">
                          <span>Previous file: </span>
                          <a href={`https://api.skyguard.group/uploads/${files.file}`} target="_blank" rel="noopener noreferrer">{files.file}</a>
                        </div>
                      )}
                    </div>

                    <div className='row'>
                      <div className='col-12 col-md-6 p-3'>
                        <label className="form-label fw-medium">Add Project Quotation</label>

                        <input
                          type="file"
                          className="form-control"
                          name="customLetter"
                          accept=".docx"
                          onChange={handleFileChange}
                          disabled={isEditMode && isLocked}
                        />
                      </div>

                      <div className="mt-3">
                        <ReactQuill value={content} onChange={setContent} />

                      </div>
                    </div>





                    <div className='col-12 col-md-6 p-3'>
                      <label className='form-label fw-medium'>Description</label>
                      <textarea className='form-control w-100' rows="5" name='description' value={formItems.description} onChange={handleChange} disabled={isEditMode && isLocked}></textarea>
                    </div>

                    <div className='col-12 col-md-6 p-3'>
                      <label className='form-label fw-medium'>Remark</label>
                      <textarea className='form-control w-100' rows="5" name='remark' value={formItems.remark} onChange={handleChange} disabled={isEditMode && isLocked}></textarea>
                    </div>

                    <div className='col-12 d-flex justify-content-center gap-2 mt-4'>
                      <button type="submit" className='btn btn-success' disabled={isEditMode && isLocked}>{isEditMode ? "Update" : "Save"}</button>
                      <button type='button' className='btn btn-danger' onClick={() => { setShowForm(false); setIsEditMode(false); resetForm(); }}>Cancel</button>
                    </div>
                  </div>
                </div>


              </form>
            </fieldset>

          )}


          <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
            <table className='table table-bordered table-striped table-hover text-center align-middle'>
              <thead className='table-info'>
                <tr>

                  <th scope='col'>SN</th>
                  <th scope='col' >Action</th>
                  <th scope='col' > Doc No. </th>
                  <th scope='col'>Party Name</th>
                  <th scope='col'>Added By</th>
                  <th scope='col'>Added Date</th>

                  <th scope='col'>Edit By</th>

                  <th scope='col'>Edit Date</th>


                </tr>
              </thead>
              <tbody>
                {filterQuotation.map((p, i) => (
                  <tr key={p.id}>
                    <td> {filterQuotation.length - i} </td>


                    <td>

                      <button
                        className="btn btn-success"

                        onClick={() => handleEdit(p)}
                      >
                        <CiEdit size={20} />
                      </button>


                      {p.customLetter && (
                        <button
                          className="btn btn-primary mx-2"
                          onClick={() => handleViewLetter(p)}
                        >
                          View
                        </button>
                      )}

                      <button
                        className="btn btn-secondary mx-1"
                        onClick={() => {
                          setSelectedQuotation(p);
                          setShowDownloadModal(true);
                        }}

                      >
                        <FaDownload size={20} />
                      </button>
                    </td>
                    <td>{`SQ/${p.inv_no}/${branchDetail.code}/${fy.financial_year.split('-')[0]}`}</td>


                    <td>{p.party_name}</td>


                    <td>{p.added_name} {p.added_name_middle || ""} {p.added_name_last} </td>
                    <td>{formatDateTime(p.created_at)}  </td>

                    <td>{p.edit_name} {p.edit_name_middle || ""} {p.edit_name_last} </td>
                    <td>{formatDateTime(p.edit_date)}</td>


                  </tr>
                ))}
              </tbody>



              {showLetterModal && selectedQuotation && (
                <>
                  <div className="modal-backdrop fade show" onClick={() => setShowLetterModal(false)}></div>
                  <div className="modal d-block" tabIndex="-1">
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                      <div className="print-letter">
                        <div className="modal-content">

                          <div className="modal-header position-relative flex-column align-items-center " style={{ justifyContent: 'center', margin: '15px' }}>

                            <h3 className="text-primary mb-1" style={{ textDecoration: 'underline', marginLeft: '155px' }}>
                              STAR SIGNATURE SERVICES
                            </h3>

                            <p className="text-secondary mb-0" style={{ fontStyle: 'italic' }}>
                              Your satisfaction is our success
                            </p>


                          </div>


                          <div className="modal-body">
                            {/* Subject */}
                            <p style={{ textAlign: "justify" }}>
                              {selectedQuotation.subject && (
                                <p><b>Subject:</b> {selectedQuotation.subject}</p>
                              )}
                            </p>



                            {/* Render rich text safely */}
                            <div
                              style={{ textAlign: "justify", margin: "5px 0", fontSize: "17px", lineHeight: "1", }}
                              dangerouslySetInnerHTML={{ __html: selectedQuotation.customLetter }}
                            />

                            <p>Thank you for considering our services. We look forward to working with you.</p>
                          </div>

                          <div className="modal-footer print-hide">


                            <button
                              type="button"
                              className="btn btn-sm btn-secondary "
                              onClick={() => setShowLetterModal(false)}
                            >
                              Close
                            </button>



                            <button
                              type="button"
                              className="btn btn-primary btn-sm"
                              onClick={() => {
                                const modalContent = document.querySelector('.print-letter');
                                if (modalContent) {
                                  const printWindow = window.open('', '', 'width=1000,height=600');

                                  printWindow.document.write(`
        <html>
          <head>
            <title>Print Quotation</title>
            <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css">
            <style>
              body { font-family: Arial, sans-serif; margin: 20px; }
              .modal-content { display: block; }
              .modal-body { white-space: pre-wrap; line-height: 1.5; font-size: 16px; }
              button { display: none; } /* hide buttons */
            </style>
          </head>
          <body>
            ${modalContent.innerHTML}
          </body>
        </html>
      `);
                                  printWindow.document.close();
                                  printWindow.focus();
                                  printWindow.print();
                                  printWindow.close();
                                }
                              }}
                            >
                              Print
                            </button>


                            <button
                              type="button"
                              className="btn btn-success btn-sm"
                              onClick={() => {
                                const modalContent = document.querySelector('.print-letter');
                                if (!modalContent) return alert("Modal content not found");

                                // Get all text content, split by line breaks
                                const textContent = modalContent.innerText.split("\n").map(line => [line]);

                                // Create worksheet from array of arrays
                                const ws = XLSX.utils.aoa_to_sheet(textContent);
                                const wb = XLSX.utils.book_new();
                                XLSX.utils.book_append_sheet(wb, ws, "Quotation");

                                // Save as Excel
                                XLSX.writeFile(wb, "Quotation.xlsx");
                              }}
                            >
                              Export to Excel
                            </button>


                          </div>

                          {/* Footer Buttons */}
                          <div className="d-flex justify-content-end gap-2 mt-4 ">



                          </div>


                        </div>
                      </div>

                    </div>
                  </div>
                </>
              )}


              {/* {showDownloadModal && selectedQuotation && (() => {
                const parsedItems = selectedQuotation.items
                  ? JSON.parse(selectedQuotation.items)
                  : [];

                const parsedAdditionalDetails = selectedQuotation.additional_charges
                  ? JSON.parse(selectedQuotation.additional_charges)
                  : [];


                const headerImageUrl = `https://api.skyguard.group/uploads/${branchDetail.header_img}`;

                return (
                  <div
                    className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                    style={{
                      backgroundColor: "rgba(0,0,0,0.5)",
                      zIndex: 9999,
                    }}
                  >

                    <div
                      style={{
                        background: "#fff",
                        width: "90%",
                        maxWidth: "900px",
                        borderRadius: "8px",
                        padding: "20px",
                        maxHeight: "90vh",
                        overflowY: "auto",
                        position: "relative",
                      }}
                    >

                      <button
                        onClick={() => setShowDownloadModal(false)}
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "10px",
                          border: "none",
                          background: "transparent",
                          fontSize: "20px",
                          cursor: "pointer",
                        }}
                      >
                        ✖
                      </button>




                      <div id="invoice-print-area" style={{ position: "relative" }}>
                        <img
                          src={headerImageUrl}
                          alt="header"
                          style={{
                            position: "absolute",
                            top: "30%",
                            left: "50%",
                            width: "350px",
                            height: "350px",
                            opacity: "0.2",
                            transform: "translate(-50%, -50%)",
                            zIndex: "0",
                          }}
                        />
                        <div style={{ position: "relative", zIndex: 1 }}>



                          <h3 style={{ textAlign: "center", marginBottom: "5px" }}>Sale Quatation</h3>




                          <table style={{ width: "100%", borderCollapse: "collapse" }} border="1">
                            <tbody >
                              <tr >
                                <td style={{ width: "60%", padding: "8px" }} className='text-start'>

                                  <table style={{ width: "100%" }} >
                                    <tbody>
                                      <tr>{company.name} </tr>
                                      <tr> {company.address} </tr>
                                      <tr>Phone: {company.phone} </tr>
                                      <tr> GSTIN: {company.gst} </tr>
                                      <tr>Email : {company.email} </tr>
                                      <tr>Pan : {company.pan} </tr>
                                    </tbody>
                                  </table>


                                </td>

                                <td style={{ width: "40%" }} >

                                  <table style={{ width: "95%" }} className='text-start'>

                                    <tbody >

                                      <tr>
                                        <td>Date</td>
                                        <td>{selectedQuotation.quotation_date}</td>
                                      </tr>
                                      <tr>
                                        <td>Shipping Address
                                        </td>
                                        <td>{selectedQuotation.delivery}</td>
                                      </tr>


                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>


                          <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "5px" }} border="1">
                            <tbody>
                              <tr>
                                <td style={{ width: "50%", padding: "8px" }} className='text-start'>
                                  <b>Party Detail:</b><br />
                                  <table style={{ width: "100%" }} >
                                    <tbody >
                                      <tr>{selectedQuotation.party_name} </tr>
                                      <tr> {selectedQuotation.party_address} </tr>

                                      <tr>{selectedQuotation.party_state} , {selectedQuotation.party_city} </tr>
                                      <tr> {selectedQuotation.party_region}, {selectedQuotation.party_pincode}  </tr>
                                      <tr>Phone: {selectedQuotation.party_phone} </tr>
                                      <tr>  Email: {selectedQuotation.party_email}</tr>
                                      <tr>  CIN No. :{selectedQuotation.party_cin}  </tr>
                                      <tr>  MSME :{selectedQuotation.party_msme} </tr>

                                    </tbody>
                                  </table>
                                </td>

                              </tr>
                            </tbody>
                          </table>


                          <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "5px" }} border="1" className='table table-bordered table-striped table-hover text-center align-middle'>
                            <thead>
                              <tr>
                                <th>Sr No</th>
                                <th>Description of Goods</th>
                           
                                <th>Qty</th>

                                <th>Rate</th>

                                <th>Amount</th>
                              </tr>
                            </thead>

                            <tbody>
                              {parsedItems.map((item, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{item.name}</td>

                                  <td>{item.qty}</td>

                                  <td>{item.rate}</td>

                                  <td>{item.amount}</td>
                                </tr>
                              ))}


                              {parsedAdditionalDetails.length > 0 && (
                                <>
                                  <tr>
                                    <td colSpan="5" style={{ textAlign: "left", fontWeight: "bold" }}>
                                      Additional Charges
                                    </td>
                                  </tr>

                                  {parsedAdditionalDetails.map((row, index) => (
                                    <tr key={index}>
                                      <td colSpan="4" style={{ textAlign: "right" }}>
                                        {row.type}
                                      </td>
                                      <td style={{ textAlign: "right" }}>
                                        {Number(row.value2 || 0).toFixed(2)}
                                      </td>
                                    </tr>
                                  ))}
                                </>
                              )}

                              <tr>
                                <td colSpan="4" style={{ textAlign: "right" }}><b>Total</b></td>
                                <td><b>{selectedQuotation.grand_total}</b></td>
                              </tr>
                            </tbody>
                          </table>


                          <div style={{ marginTop: "5px", border: "1px solid #000", padding: "5px" }} className='text-start'>
                            <b>Amount Chargeable (In Words):</b> Rupees Only
                          </div>


                          <table
                            style={{ width: "100%", borderCollapse: "collapse", marginTop: "5px" }}
                            border="1"
                          >
                            <tbody>
                              <tr>

                           
                                <td style={{ width: "50%", padding: "8px", verticalAlign: "top" }}>

                                  <div style={{ border: "1px solid #000", padding: "8px" }}>
                                    <b>Company Bank Details:</b>

                                    <table style={{ width: "100%", marginTop: "5px" }} className='table table-bordered table-striped table-hover text-center align-middle'>
                                      <tbody>
                                        <tr>
                                          <td>Bank Name</td>
                                          <td>{company.bank_name} </td>
                                        </tr>
                                        <tr>
                                          <td>Account No</td>
                                          <td>{company.acc_no}  </td>
                                        </tr>
                                        <tr>
                                          <td>IFSC Code</td>
                                          <td>{company.ifsc} </td>
                                        </tr>
                                        <tr>
                                          <td>Branch</td>
                                          <td>{company.branch} </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>

                                </td>

                              
                                <td style={{ width: "50%", padding: "8px", verticalAlign: "top" }}>

                                  <div style={{ border: "1px solid #000", padding: "8px" }}>
                                    <b>Party Bank Details:</b>

                                    <table style={{ width: "100%", marginTop: "5px" }} className='table table-bordered table-striped table-hover text-center align-middle'>
                                      <tbody>
                                        <tr>
                                          <td>Bank Name</td>
                                          <td>-</td>
                                        </tr>
                                        <tr>
                                          <td>Account No</td>
                                          <td> - </td>
                                        </tr>
                                        <tr>
                                          <td>IFSC Code</td>
                                          <td>- </td>
                                        </tr>
                                        <tr>
                                          <td>Branch</td>
                                          <td>- </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>

                                </td>

                              </tr>
                            </tbody>
                          </table>




                          <table style={{ width: "100%", borderCollapse: "collapse" }}>
                            <tbody>
                              <tr>
                                <td
                                  style={{
                                    width: "100%",
                                    padding: "8px",
                                    verticalAlign: "top",
                                    textAlign: "right",
                                  }}
                                >
                                  <div
                                    style={{
                                      border: "1px solid #000",
                                      height: "160px",
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      alignItems: "flex-end",
                                      padding: "10px",
                                    }}
                                  >
                                    <b>Authorised Signatory</b>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>



                          <table className="table table-start">
                            <tbody>
                              <tr>
                                <td
                                  style={{
                                    width: "34%",
                                    padding: "8px",
                                    verticalAlign: "top",
                                    textAlign: "left",
                                  }}
                                >
                                  <div
                                    style={{
                                      border: "1px solid #000",
                                      height: "160px",
                                      paddingBottom: "10px",
                                      textAlign: "left",
                                    }}
                                  >
                                    <strong>T & C :</strong>

                                    {selectedQuotation.remark
                                      ?.split(/(?=\d+\.)/)
                                      .map((item, index) => (
                                        <div key={index} style={{ textAlign: "left" }}>
                                          {item.trim()}
                                        </div>
                                      ))}
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>


                          <div style={{ textAlign: "center", marginTop: "5px", fontSize: "12px" }}>
                            SUBJECT TO MUMBAI JURISDICTION  We are registered under MSME Act2006, Our MSME no is 'UDYAM-MH-18-0006676
                          </div>

                        </div>


                        <div
                          className="no-print"
                          style={{ marginTop: "15px", textAlign: "right" }}
                        >
                          <button
                            onClick={handlePrint}
                            style={{
                              marginRight: "10px",
                              padding: "8px 15px",
                              background: "#007bff",
                              color: "#fff",
                              border: "none",
                              borderRadius: "4px",
                            }}
                          >
                            Print
                          </button>

                          <button
                            onClick={() => setShowDownloadModal(false)}
                            style={{
                              padding: "8px 15px",
                              background: "red",
                              color: "#fff",
                              border: "none",
                              borderRadius: "4px",
                            }}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>

                    </div>

              
                    <style>
                      {`
          @media print {
            .no-print {
              display: none !important;
            }
          }
        `}
                    </style>
                  </div>
                );
              })()} */}


            </table>
          </div>
          {hasMore && (
            <div className="text-center mt-3">
              <button
                className="btn btn-primary"
                onClick={handleLoadMore}
              >
                Load More
              </button>
            </div>
          )}


             {showDownloadModal && selectedQuotation && (() => {
                                                              const parsedItems = selectedQuotation.items
                                                                  ? JSON.parse(selectedQuotation.items)
                                                                  : [];
                                      
                                                              const parsedAdditionalDetails = selectedQuotation.additional_charges
                                                                  ? JSON.parse(selectedQuotation.additional_charges)
                                                                  : [];
                                      
                                      
                                                              const headerImageUrl = `https://api.skyguard.group/uploads/${branchDetail.header_img}`;
                                      
                                                              return (
                                                                  <>
                                                                      <div
                                                                          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                                                                          style={{
                                                                              backgroundColor: "rgba(0,0,0,0.5)",
                                                                              zIndex: 9999,
                                                                          }}
                                                                      >
                                      
                                                                          <div
                                                                              style={{
                                                                                  background: "transparent",
                                                                                  width: "95%",
                                                                                  maxWidth: "1000px",
                                                                                  borderRadius: "0",
                                                                                  padding: "0",
                                                                                  maxHeight: "95vh",
                                                                                  overflowY: "auto",
                                                                                  position: "relative",
                                                                                  boxShadow: "none",
                                                                              }}
                                                                          >
                                      
                                                                              <button
                                                                                  onClick={() => setShowDownloadModal(false)}
                                                                                  style={{
                                                                                      position: "absolute",
                                                                                      top: "10px",
                                                                                      right: "10px",
                                                                                      border: "none",
                                                                                      background: "transparent",
                                                                                      fontSize: "20px",
                                                                                      cursor: "pointer",
                                                                                  }}
                                                                              >
                                                                                  ✖
                                                                              </button>
                                      
                                      
                                                                              <div
                                                                                  id="invoice-print-area"
                                                                                  style={{
                                                                                      position: "relative",
                                                                                      background: "#fff",
                                                                                      border: "2px solid #000",
                                                                                      fontFamily: "Arial",
                                                                                      fontSize: "13px",
                                                                                  }}
                                                                              >
                                      
                                                                                  {/* Watermark */}
                                                                                  <img
                                                                                      src={headerImageUrl}
                                                                                      alt=""
                                                                                      style={{
                                                                                          position: "absolute",
                                                                                          top: "45%",
                                                                                          left: "50%",
                                                                                          transform: "translate(-50%,-50%)",
                                                                                          width: "350px",
                                                                                          opacity: 0.09,
                                                                                          zIndex: 0,
                                                                                      }}
                                                                                  />
                                      
                                                                                  <div style={{ position: "relative", zIndex: 2 }}>
                                      
                                                                                      {/* ================= HEADER ================= */}
                                      
                                                                                      <div
                                                                                          style={{
                                                                                              display: "flex",
                                                                                              borderBottom: "2px solid #000",
                                                                                              minHeight: "70px",
                                                                                          }}
                                                                                      >
                                      
                                                                                          {/* Title */}
                                      
                                                                                          <div
                                                                                              style={{
                                                                                                  flex: 1,
                                                                                             
                                                                                                  color: "#fff",
                                                                                                  background: "#2badea",
                                                                                                  display: "flex",
                                                                                                  alignItems: "center",
                                                                                                  justifyContent: "center",
                                                                                                  fontSize: "28px",
                                                                                                  fontWeight: "bold",
                                                                                                  letterSpacing: 1,
                                                                                              }}
                                                                                          >
                                                                                              SALE QUOTATION
                                                                                          </div>
                                      
                                                                                          {/* Logo */}
                                      
                                                                                          {/* <div
                                                                                              style={{
                                                                                                  width: "120px",
                                                                                                  borderLeft: "2px solid #000",
                                                                                                  display: "flex",
                                                                                                  justifyContent: "center",
                                                                                                  alignItems: "center",
                                                                                              }}
                                                                                          >
                                                                                              {branchDetail?.header_img ? (
                                                                                                  <img
                                                                                                      src={headerImageUrl}
                                                                                                      alt=""
                                                                                                      style={{
                                                                                                          width: "320px",
                                                                                                          height: "60px",
                                                                                                          objectFit: "contain",
                                                                                                      }}
                                                                                                  />
                                                                                              ) : (
                                                                                                  <h3>LOGO</h3>
                                                                                              )}
                                                                                          </div> */}
                                      
                                                                                      </div>
                                      
                                                                                      {/* ================= COMPANY + INVOICE ================= */}
                                      <div
                                        style={{
                                          display: "flex",
                                          border: "1px solid #423d3d",
                                          width: "100%",
                                        }}
                                      >
                                        {/* Left Side - Logo */}
                                        <div
                                          style={{
                                            width: "20%",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            borderRight: "1px solid #ebcccc",
                                            padding: "10px",
                                            minHeight: "220px",
                                          }}
                                        >
                                          {branchDetail?.header_img ? (
                                            <img
                                              src={headerImageUrl}
                                              alt="Company Logo"
                                              style={{
                                              width: "300px",    
                                              height: "200px",     
                                              maxWidth: "100%",
                                              objectFit: "contain",
                                            }}
                                            />
                                          ) : (
                                            <h3>LOGO</h3>
                                          )}
                                        </div>
                                      
                                        {/* Right Side - Company Details */}
                                        <div
                                          style={{
                                            width: "80%",
                                            padding: "10px 15px",
                                              fontSize: "15px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          <h6
                                            style={{
                                              marginBottom: 10,
                                              fontWeight: "bold",
                                              color: "var(--invoice-header)",
                                            }}
                                          >
                                            COMPANY DETAILS
                                          </h6>
                                      
                                          <div><b>{company.name}</b></div>
                                          <div>{company.address}</div>
                                          <div>{company.city}, {company.state}</div>
                                          <div>PIN : {company.pincode}</div>
                                          <div>GSTIN : {company.gst}</div>
                                          <div>PHONE : {company.phone}</div>
                                          <div>EMAIL : {company.email}</div>
                                          <div>PAN : {company.pan}</div>
                                        </div>
                                      </div>
                                      
                                                                                      {/* BUYER DETAILS START HERE */}
                                      
                                      
                                                                                      {/* ================= BUYER + TERMS ================= */}
                                      
                                                                                      <div
                                                                                          style={{
                                                                                              width: "100%",
                                                                                              padding: "2px",
                                                                                          marginBottom:'8px',
                                                                                          }}
                                                                                      >
                                                                                          
                                                                                                <div
                                                                                              style={{
                                                                                                  width: "48%",
                                                                                              }}
                                                                                          >
                                                                                              
                                      
                                                                                          </div>
                                      
                                      <div
                                        style={{
                                          display: "flex",
                                          padding: "12px",
                                          fontSize: "14px",
                                        }}
                                      >
                                         
                                      
                                        
                                        {/* Left Side */}
                                        <div
                                          style={{
                                            width: "50%",
                                            paddingRight: "20px",
                                            borderRight: "1px solid #ddd",
                                          }}
                                        >
                                        <div
                                          style={{
                                            fontSize: "15px",
                                            fontWeight: "bold",
                                            color: "var(--invoice-header)",
                                            marginBottom: "15px",
                                            borderBottom: "1px solid #ddd",
                                            paddingBottom: "6px",
                                          }}
                                        >
                                          Customer Details
                                        </div>
                                          
                                          <div style={{ display: "flex", marginBottom: "10px" }}>
                                            <div style={{ width: "40%", fontWeight: "600" }}>Name</div>
                                            <div style={{ width: "60%" }}>{selectedQuotation.party_name}</div>
                                          </div>
                                      
                                          <div style={{ display: "flex", marginBottom: "10px" }}>
                                            <div style={{ width: "40%", fontWeight: "600" }}>Mobile</div>
                                            <div style={{ width: "60%" }}>{selectedQuotation.party_phone}</div>
                                          </div>
                                      
                                          <div style={{ display: "flex", marginBottom: "10px" }}>
                                            <div style={{ width: "40%", fontWeight: "600" }}>Email</div>
                                            <div style={{ width: "60%" }}>{selectedQuotation.party_email}</div>
                                          </div>
                                      
                                          <div style={{ display: "flex", marginBottom: "10px" }}>
                                            <div style={{ width: "40%", fontWeight: "600" }}>Billing Address</div>
                                            <div style={{ width: "60%" }}>{selectedQuotation.party_address}</div>
                                          </div>
                                      
                                          <div style={{ display: "flex" }}>
                                            <div style={{ width: "40%", fontWeight: "600" }}>Shipping Address</div>
                                            <div style={{ width: "60%" }}>{selectedQuotation.delivery}</div>
                                          </div>
                                        </div>
                                      
                                        {/* Right Side */}
                                        <div
                                          style={{
                                            width: "50%",
                                            paddingLeft: "20px",
                                          }}
                                        >
                                        <div
                                          style={{
                                            fontSize: "15px",
                                            fontWeight: "bold",
                                            color: "var(--invoice-header)",
                                            marginBottom: "15px",
                                            borderBottom: "1px solid #ddd",
                                            paddingBottom: "6px",
                                          }}
                                        >
                                          Quotation Details
                                        </div>
                                          
                                          <div style={{ display: "flex", marginBottom: "10px" }}>
                                            <div style={{ width: "40%", fontWeight: "600" }}>Quotation No.</div>
                                            <div style={{ width: "60%" }}>{selectedQuotation.inv_no}</div>
                                          </div>
                                      
                                          <div style={{ display: "flex", marginBottom: "10px" }}>
                                            <div style={{ width: "40%", fontWeight: "600" }}>Date</div>
                                            <div style={{ width: "60%" }}>{formatDateTime(selectedQuotation.date)}</div>
                                          </div>
                                      
                                          <div style={{ display: "flex", marginBottom: "10px" }}>
                                            <div style={{ width: "40%", fontWeight: "600" }}>GST No.</div>
                                            <div style={{ width: "60%" }}>{selectedQuotation.party_gst}</div>
                                          </div>
                                      
                                          <div style={{ display: "flex", marginBottom: "10px" }}>
                                            <div style={{ width: "40%", fontWeight: "600" }}>PAN No.</div>
                                            <div style={{ width: "60%" }}>{selectedQuotation.party_pan}</div>
                                          </div>
                                      
                                          <div style={{ display: "flex", marginBottom: "10px" }}>
                                            <div style={{ width: "40%", fontWeight: "600" }}>MSME No.</div>
                                            <div style={{ width: "60%" }}>{selectedQuotation.party_msme}</div>
                                          </div>
                                      
                                          <div style={{ display: "flex", marginBottom: "10px" }}>
                                            <div style={{ width: "40%", fontWeight: "600" }}>State</div>
                                            <div style={{ width: "60%" }}>{selectedQuotation.party_state}</div>
                                          </div>
                                      
                                          <div style={{ display: "flex" }}>
                                            <div style={{ width: "40%", fontWeight: "600" }}>City</div>
                                            <div style={{ width: "60%" }}>{selectedQuotation.party_city}</div>
                                          </div>
                                        </div>
                                      </div>
                                      
                                                                                   
                                                                                          {/* <div style={{ display: "flex", marginBottom: "6px" }}>
                                                                                              <div style={{ flex: 1 }}>
                                                                                                  <b>Party Name</b><br />
                                                                                                  {selectedQuotation.party_name}
                                                                                              </div>
                                      
                                                                                              <div style={{ flex: 1 }}>
                                                                                                  <b>Phone</b><br />
                                                                                                  {selectedQuotation.party_phone}
                                                                                              </div>
                                      
                                                                                              <div style={{ flex: 1 }}>
                                                                                                  <b>Email</b><br />
                                                                                                  {selectedQuotation.party_email}
                                                                                              </div>
                                                                                          </div>
                                      
                                                                                      
                                                                                          <div style={{ display: "flex", marginBottom: "12px" }}>
                                                                                              <div style={{ flex: 1 }}>
                                                                                                  <b>State</b><br />
                                                                                                  {selectedQuotation.party_state}
                                                                                              </div>
                                      
                                                                                              <div style={{ flex: 1 }}>
                                                                                                  <b>City</b><br />
                                                                                                  {selectedQuotation.party_city}
                                                                                              </div>
                                      
                                                                                              <div style={{ flex: 1 }}>
                                                                                                  <b>Pincode</b><br />
                                                                                                  {selectedQuotation.party_pincode}
                                                                                              </div>
                                                                                          </div>
                                      
                                                                                    
                                                                                          <div style={{ display: "flex", marginBottom: "12px" }}>
                                                                                              <div style={{ flex: 1 }}>
                                                                                                  <b>Region</b><br />
                                                                                                  {selectedQuotation.party_region}
                                                                                              </div>
                                      
                                                                                              <div style={{ flex: 1 }}>
                                                                                                  <b>CIN No</b><br />
                                                                                                  {selectedQuotation.party_cin}
                                                                                              </div>
                                      
                                                                                              <div style={{ flex: 1 }}>
                                                                                                  <b>MSME</b><br />
                                                                                                  {selectedQuotation.party_msme}
                                                                                              </div>
                                                                                          </div>
                                      
                                                                                   
                                                                                          <div style={{ display: "flex" }}>
                                                                                              <div style={{ flex: 3 }}>
                                                                                                  <b>Address</b><br />
                                                                                                  {selectedQuotation.party_address}
                                                                                              </div>
                                                                                          </div>
                                      
                                                                                          <div style={{ display: "flex" }}>
                                                                                              <div style={{ flex: 3 }}>
                                                                                                  <b>Shiping Address</b><br />
                                                                                                  {selectedQuotation.shipping_address}
                                                                                              </div>
                                                                                          </div>
                                      
                                                                                          <div style={{ display: "flex" }}>
                                                                                              <div style={{ flex: 3 }}>
                                                                                                  <b>GST</b><br />
                                                                                                  {selectedQuotation.party_gst}
                                                                                              </div>
                                                                                          </div> */}
                                                                                      </div>
                                      
                                                                                      {/* ================= ITEMS TABLE START ================= */}
                                      
                                      
                                                                                      <table
                                                                                          style={{
                                                                                              width: "100%",
                                                                                              borderCollapse: "collapse",
                                                                                              fontSize: "10px",
                                                                                          }}
                                                                                      >
                                      
                                                                                          <thead>
                                      
                                                                                              <tr
                                                                                                  style={{
                                                                                                      // background: "#d88aa8",
                                                                                                      background: 'var(--invoice-header)',
                                                                                                      color: "#000",
                                                                                                  }}
                                                                                              >
                                      
                                                                                                  <th style={thStyle}>SL</th>
                                      
                                                                                                  <th style={thStyle}>ITEM / DESCRIPTION</th>
                                      
                                                                                                  <th style={thStyle}>HSN</th>
                                      
                                                                                                  <th style={thStyle}>QTY</th>
                                                                                                  <th style={thStyle}>RATE</th>
                                                                                                  <th style={thStyle}>GST</th>
                                      
                                                                                                  <th style={thStyle}>AMOUNT</th>
                                      
                                                                                              </tr>
                                      
                                                                                          </thead>
                                      
                                                                                          <tbody>
                                      
                                                                                              {parsedItems.map((item, index) => (
                                      
                                                                                                  <tr key={index}>
                                      
                                                                                                      <td style={tdCenter}>
                                                                                                          {index + 1}
                                                                                                      </td>
                                      
                                                                                                      <td style={tdLeft}>
                                                                                                          {item.name}
                                                                                                      </td>
                                      
                                                                                                      <td style={tdCenter}>
                                                                                                          {item.hsn || "-"}
                                                                                                      </td>
                                      
                                                                                                      <td style={tdCenter}>
                                                                                                          {item.qty}
                                                                                                      </td>
                                      
                                      
                                                                                                      <td style={tdRight}>
                                                                                                          ₹ {Number(item.rate).toFixed(2)}
                                                                                                      </td>
                                      
                                                                                                      <td style={tdRight}>
                                                                                                          {Number(item.tax).toFixed(2)}
                                                                                                      </td>
                                      
                                                                                                      <td style={tdRight}>
                                                                                                          ₹ {Number(item.totalAmount).toFixed(2)}
                                                                                                      </td>
                                      
                                                                                                  </tr>
                                      
                                                                                              ))}
                                      
                                      
                                      
                                                                                              {Array.from({
                                                                                                  length: Math.max(0, 3 - parsedItems.length),
                                                                                              })
                                      
                                                                                              }
                                      
                                                                                              {/* Additional Charges */}
                                      
                                                                                              {parsedAdditionalDetails.length > 0 && (
                                      
                                                                                                  parsedAdditionalDetails.map((charge, index) => (
                                      
                                                                                                      <tr key={index}>
                                      
                                                                                                          <td
                                                                                                              colSpan="6"
                                                                                                              style={{
                                                                                                                  border: "1px solid #000",
                                                                                                                  textAlign: "right",
                                                                                                                  padding: "6px",
                                                                                                                  fontWeight: "bold",
                                                                                                              }}
                                                                                                          >
                                                                                                              {charge.type}
                                                                                                          </td>
                                      
                                                                                                          <td style={tdRight}>
                                                                                                              ₹ {Number(charge.value2 || 0).toFixed(2)}
                                                                                                          </td>
                                      
                                                                                                      </tr>
                                      
                                                                                                  ))
                                      
                                                                                              )}
                                      
                                                                                          </tbody>
                                      
                                                                                      </table>
                                      
                                      
                                                                                      {/* ===================== SUMMARY ===================== */}
                                      
                                                                                      <div
                                                                                          style={{
                                                                                              display: "flex",
                                                                                              border: "2px solid #000",
                                                                                              borderTop: "none",
                                                                                              minHeight: "170px",
                                                                                              marginTop:"8px",
                                                                                          }}
                                                                                      >
                                      
                                                                                          {/* LEFT */}
                                      
                                                                                          <div
                                                                                              style={{
                                                                                                  width: "60%",
                                                                                                  borderRight: "2px solid #000",
                                                                                                  padding: "12px",
                                                                                              }}
                                                                                          >
                                      
                                                                                              <div
                                                                                                  style={{
                                                                                                      fontWeight: "bold",
                                                                                                      // color: "#9d1f4f",
                                                                                                      color: 'var(--invoice-header)',
                                                                                                      fontSize: "16px",
                                                                                                      marginBottom: "10px",
                                                                                                  }}
                                                                                              >
                                                                                                  AMOUNT IN WORDS
                                                                                              </div>
                                      
                                                                                              <div
                                                                                                  style={{
                                                                                                      minHeight: "45px",
                                                                                                      border: "1px solid #000",
                                                                                                      padding: "8px",
                                                                                                      marginBottom: "15px",
                                                                                                  }}
                                                                                              >
                                                                                                  {
                                                                                                      "Rupees " +
                                                                                                      toWords(Math.round(Number(selectedQuotation.grand_total || 0)))
                                                                                                          .replace(/\b\w/g, (char) => char.toUpperCase()) +
                                                                                                      " Only"
                                                                                                  }
                                                                                              </div>
                                      
                                                                                              <div
                                                                                                  style={{
                                                                                                      fontWeight: "bold",
                                                                                                      // color: "#9d1f4f",
                                                                                                      color: 'var(--invoice-header)',
                                                                                                      fontSize: "16px",
                                                                                                      marginBottom: "10px",
                                                                                                  }}
                                                                                              >
                                                                                                  Term & Condition
                                                                                              </div>
                                      
                                                                                              <div
                                                                                                  style={{
                                                                                                      minHeight: "55px",
                                                                                                      border: "1px solid #000",
                                                                                                      padding: "8px",
                                                                                                  }}
                                                                                              >
                                                                                                  {selectedQuotation.remark
                                                                                                      ? selectedQuotation.remark
                                                                                                          .split(/(?=\d+\.)/)
                                                                                                          .map((item, index) => (
                                                                                                              <div key={index}>
                                                                                                                  {item.trim()}
                                                                                                              </div>
                                                                                                          ))
                                                                                                      : (
                                                                                                          <>
                                                                                                              <div>1. Goods once sold will not be taken back.</div>
                                      
                                                                                                              <div>2. Subject to Mumbai Jurisdiction.</div>
                                      
                                                                                                              <div>3. Delivery as per commitment.</div>
                                      
                                                                                                              <div>4. Payment as agreed.</div>
                                      
                                                                                                              <div>5. Thank you for your business.</div>
                                                                                                          </>
                                                                                                      )}
                                                                                              </div>
                                      
                                                                                          </div>
                                      
                                                                                          {/* RIGHT */}
                                      
                                                                                          <div
                                                                                              style={{
                                                                                                  width: "40%",
                                                                                              }}
                                                                                          >
                                      
                                                                                              <table
                                                                                                  style={{
                                                                                                      width: "100%",
                                                                                                      borderCollapse: "collapse",
                                                                                                      height: "100%",
                                                                                                  }}
                                                                                              >
                                      
                                                                                                  <tbody>
                                      
                                                                                                      <tr>
                                      
                                                                                                          <td style={summaryTitle}>
                                                                                                              Sub Total
                                                                                                          </td>
                                      
                                                                                                          <td style={summaryValue}>
                                                                                                              ₹ {Number(selectedQuotation.sub_total || selectedQuotation.grand_total).toFixed(2)}
                                                                                                          </td>
                                      
                                                                                                      </tr>
                                      
                                      
                                      
                                                                                                      {parsedAdditionalDetails.map((charge, index) => {
                                      
                                                                                                          const gstPercent = Number(charge.gst || 0);
                                                                                                          const chargeAmount = Number(charge.charge_amount || charge.value2 || 0);
                                                                                                          const gstAmount = Number(charge.gst_amount || 0);
                                                                                                          const finalAmount = chargeAmount + gstAmount;
                                      
                                                                                                          // Check if this is a transport charge
                                                                                                          const isTransport =
                                                                                                              charge.type?.toLowerCase().includes("transport") ||
                                                                                                              charge.type?.toLowerCase().includes("transportation")
                                      
                                      
                                                                                                          return (
                                                                                                              <tr key={index}>
                                                                                                                  <td style={summaryTitle}>
                                                                                                                      {charge.type}
                                      
                                                                                                                      {isTransport && gstPercent > 0 && (
                                                                                                                          <>
                                                                                                                              <span style={{ fontWeight: "normal" }}>
                                                                                                                                  {" "} ( GST {gstPercent}%)
                                                                                                                              </span>
                                                                                                                              <span className='text-primary'>
                                                                                                                                  SAC 9968
                                                                                                                              </span>
                                                                                                                          </>
                                                                                                                      )}
                                                                                                                  </td>
                                      
                                                                                                                  <td style={summaryValue}>
                                                                                                                      ₹ {finalAmount.toFixed(2)}
                                                                                                                  </td>
                                                                                                              </tr>
                                                                                                          );
                                      
                                                                                                      })}
                                                                                                      <tr>
                                      
                                                                                                          <td style={summaryTitle}>
                                                                                                              Discount
                                                                                                          </td>
                                      
                                                                                                          <td style={summaryValue}>
                                                                                                              ₹ {Number(selectedQuotation.bill_discount_value || 0).toFixed(2)}
                                                                                                          </td>
                                      
                                                                                                      </tr>
                                      
                                                                                                      <tr>
                                      
                                                                                                          <td style={summaryTitle}>
                                                                                                              CGST
                                                                                                          </td>
                                      
                                                                                                          <td style={summaryValue}>
                                                                                                              ₹ {Number(selectedQuotation.cgst || 0).toFixed(2)}
                                                                                                          </td>
                                      
                                                                                                      </tr>
                                      
                                                                                                      <tr>
                                      
                                                                                                          <td style={summaryTitle}>
                                                                                                              SGST
                                                                                                          </td>
                                      
                                                                                                          <td style={summaryValue}>
                                                                                                              ₹ {Number(selectedQuotation.sgst || 0).toFixed(2)}
                                                                                                          </td>
                                      
                                                                                                      </tr>
                                      
                                                                                                      <tr>
                                      
                                                                                                          <td style={summaryTitle}>
                                                                                                              IGST
                                                                                                          </td>
                                      
                                                                                                          <td style={summaryValue}>
                                                                                                              ₹ {Number(selectedQuotation.igst || 0).toFixed(2)}
                                                                                                          </td>
                                      
                                                                                                      </tr>
                                      
                                                                                                      <tr>
                                      
                                                                                                          <td style={summaryTitle}>
                                                                                                              Round Off
                                                                                                          </td>
                                      
                                                                                                          <td style={summaryValue}>
                                                                                                              ₹ {Number(selectedQuotation.round_off || 0).toFixed(2)}
                                                                                                          </td>
                                      
                                                                                                      </tr>
                                      
                                                                                                      <tr
                                                                                                          style={{
                                                                                                              // background: "#d88aa8",
                                                                                                              background: 'var(--invoice-header)',
                                                                                                              fontWeight: "bold",
                                                                                                              fontSize: "16px",
                                                                                                          }}
                                                                                                      >
                                      
                                                                                                          <td
                                                                                                              style={{
                                                                                                                  border: "1px solid #000",
                                                                                                                  padding: "10px",
                                                                                                                  color:'white'
                                                                                                              }}
                                                                                                          >
                                                                                                              GRAND TOTAL
                                                                                                          </td>
                                      
                                                                                                          <td
                                                                                                              style={{
                                                                                                                  border: "1px solid #000",
                                                                                                                  padding: "10px",
                                                                                                                  textAlign: "right",
                                                                                                                   color:'white'
                                                                                                              }}
                                                                                                          >
                                                                                                              ₹ {Number(selectedQuotation.grand_total).toFixed(2)}
                                                                                                          </td>
                                      
                                                                                                      </tr>
                                      
                                                                                                  </tbody>
                                      
                                                                                              </table>
                                      
                                                                                          </div>
                                      
                                                                                      </div>
                                      
                                      
                                                                                      {/* ===================== BANK DETAILS ===================== */}
                                      
                                                                                      <div
                                                                                          style={{
                                                                                              display: "flex",
                                                                                              border: "2px solid #000",
                                                                                              borderTop: "none",
                                                                                          }}
                                                                                      >
                                      
                                                                                          {/* Company Bank */}
                                      
                                                                                          <div
                                                                                              style={{
                                                                                                  width: "50%",
                                                                                                  borderRight: "2px solid #000",
                                                                                                  padding: "12px",
                                                                                              }}
                                                                                          >
                                      
                                                                                              <div
                                                                                                  style={{
                                                                                                    
                                                                                                      background: 'var(--invoice-header)',
                                                                                                      padding: "8px",
                                                                                                      fontWeight: "bold",
                                                                                                      marginBottom: "10px",
                                                                                                      color:'white',
                                                                                                  }}
                                                                                              >
                                                                                                  COMPANY BANK DETAILS
                                                                                              </div>
                                      
                                                                                              <table
                                                                                                  style={{
                                                                                                      width: "100%",
                                                                                                      borderCollapse: "collapse",
                                                                                                  }}
                                                                                              >
                                      
                                                                                                  <tbody>
                                      
                                                                                                      <tr>
                                                                                                          <td style={bankTitle}>Bank Name</td>
                                                                                                          <td style={bankValue}>{company.bank_name}</td>
                                                                                                      </tr>
                                      
                                                                                                      <tr>
                                                                                                          <td style={bankTitle}>Account No.</td>
                                                                                                          <td style={bankValue}>{company.acc_no}</td>
                                                                                                      </tr>
                                      
                                                                                                      <tr>
                                                                                                          <td style={bankTitle}>IFSC</td>
                                                                                                          <td style={bankValue}>{company.ifsc}</td>
                                                                                                      </tr>
                                      
                                                                                                      <tr>
                                                                                                          <td style={bankTitle}>Branch</td>
                                                                                                          <td style={bankValue}>{company.branch}</td>
                                                                                                      </tr>
                                      
                                                                                                  </tbody>
                                      
                                                                                              </table>
                                      
                                                                                          </div>
                                      
                                      
                                                                                   <div
  style={{
    width: "50%",
    padding: "12px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  }}
>
  <div
    style={{
      background: "var(--invoice-header)",
      color: "#fff",
      padding: "8px",
      fontWeight: "bold",
      marginBottom: "10px",
      width: "100%",
      textAlign: "center",
    }}
  >
    SCAN TO PAY
  </div>

  <img
    src="/qr.png"
    alt="QR Code"
    style={{
      width: "180px",
      height: "180px",
      // objectFit: "contain",
    }}
  />
</div>
                                                                                      </div>
                                                                                      <div
                                                                                          style={{
                                                                                              border: "2px solid #000",
                                                                                              borderTop: "none",
                                                                                              minHeight: "150px",
                                                                                              display: "flex",
                                                                                              justifyContent: "flex-end",
                                                                                          }}
                                                                                      >
                                                                                          <div
                                                                                              style={{
                                                                                                  width: "35%",
                                                                                                  padding: "15px",
                                                                                                  display: "flex",
                                                                                                  flexDirection: "column",
                                                                                                  justifyContent: "space-between",
                                                                                                  alignItems: "center",
                                                                                              }}
                                                                                          >
                                                                                              <div
                                                                                                  style={{
                                                                                                      fontWeight: "bold",
                                                                                                      fontSize: "15px",
                                                                                                  }}
                                                                                              >
                                                                                                  For {company.name}
                                                                                              </div>
                                      
                                                                                              {/* Signature Space */}
                                                                                              <div
                                                                                                  style={{
                                                                                                      height: "70px",
                                                                                                      width: "100%",
                                                                                                  }}
                                                                                              ></div>
                                      
                                                                                              <div
                                                                                                  style={{
                                                                                                      borderTop: "1px solid #000",
                                                                                                      width: "100%",
                                                                                                      textAlign: "center",
                                                                                                      paddingTop: "8px",
                                                                                                      fontWeight: "bold",
                                                                                                  }}
                                                                                              >
                                                                                                  Authorized Signatory
                                                                                              </div>
                                                                                          </div>
                                                                                      </div>
                                      
                                                                                      {/* ===================== FOOTER ===================== */}
                                      
                                                                                      <div
                                                                                          style={{
                                                                                              border: "2px solid #000",
                                                                                              borderTop: "none",
                                                                                              textAlign: "center",
                                                                                              padding: "10px",
                                                                                              fontSize: "12px",
                                                                                              background: "#f8f8f8",
                                                                                          }}
                                                                                      >
                                      
                                                                                          SUBJECT TO MUMBAI JURISDICTION
                                      
                                                                                          <br />
                                      
                                                                                          Thank you for your business.
                                      
                                                                                      </div>
                                      
                                                                                      {/* ===================== BUTTONS ===================== */}
                                      
                                                                                      <div
                                                                                          className="no-print mb-2"
                                                                                          style={{
                                                                                              display: "flex",
                                                                                              justifyContent: "end",
                                                                                              gap: "10px",
                                                                                              marginTop: "20px",
                                                                                          }}
                                                                                      >
                                      
                                                                                          <button
                                                                                              className="btn btn-success"
                                                                                              onClick={handlePrint}
                                                                                          >
                                                                                              Print Invoice
                                                                                          </button>
                                      
                                                                                          <button
                                                                                              className="btn btn-danger"
                                                                                              onClick={() => setShowDownloadModal(false)}
                                                                                          >
                                                                                              Close
                                                                                          </button>
                                      
                                                                                      </div>
                                      
                                      
                                      
                                                                                  </div>
                                      
                                      
                                                                                  <style>
                                                                                      {`
                                                @media print {
                                                  .no-print {
                                                    display: none !important;
                                                  }
                                                }
                                              `}
                                                                                  </style>
                                                                              </div>
                                                                          </div>
                                                                      </div>
                                                                  </>
                                                              );
                                                          })()}
        </div>
      </div>
    </>
  )
}

export default SaleQuotation



// Export to Excel
export const exportInvoiceToExcel = (selectedQuotation) => {
  const items = selectedQuotation.items ? JSON.parse(selectedQuotation.items) : [];
  const data = items.map((item) => ({
    "Item Name": item.name,
    Qty: item.qty,
    Rate: item.rate,
    "GST %": item.tax,
    Amount: item.amount,
  }));

  // Add totals at bottom
  data.push({});
  data.push({ "Item Name": "Total GST", Amount: selectedQuotation.total_gst });
  data.push({ "Item Name": "Sub Total", Amount: selectedQuotation.sub_total });
  data.push({ "Item Name": "Grand Total", Amount: selectedQuotation.grand_total });

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Invoice");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, `Invoice_${selectedQuotation.invoice_no || "NA"}.xlsx`);
};
